<template>
  <div class="large-screen">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-left">
        <img src="../assets/images/logo_yc.png" alt="logo" class="logo" />
        <div class="filter-group">
          <span class="filter-label">场站类型：</span>
          <el-select v-model="stationType" placeholder="全部" class="filter-select" popper-class="custom-popper" style="--el-fill-color-blank: transparent;">
            <el-option label="全部" value="all"></el-option>
            <el-option label="高速" :value="1"></el-option>
            <el-option label="市区" :value="2"></el-option>
            <el-option label="内部" :value="3"></el-option>
          </el-select>
        </div>
        <div class="filter-group">
          <span class="filter-label">所属区域：</span>
          <el-select v-model="region" placeholder="全国" class="filter-select" popper-class="custom-popper" style="--el-fill-color-blank: transparent;">
            <el-option label="全国" value=""></el-option>
            <el-option label="广东省" value="440000"></el-option>
            <el-option label="福建省" value="350000"></el-option>
            <el-option label="安徽省" value="340000"></el-option>
            <el-option label="广西省" value="450000"></el-option>
            <el-option label="浙江省" value="330000"></el-option>
            <el-option label="江苏省" value="320000"></el-option>
            <el-option label="北京" value="110000"></el-option>
            <el-option label="上海" value="310000"></el-option>
            <!-- <el-option label="河北省" value="130000"></el-option> -->
            <!-- <el-option label="山西省" value="140000"></el-option> -->
            <!-- <el-option label="辽宁省" value="210000"></el-option> -->
            <!-- <el-option label="吉林省" value="220000"></el-option> -->
            <!-- <el-option label="黑龙江省" value="230000"></el-option> -->
            <!-- <el-option label="山东省" value="370000"></el-option> -->
            <!-- <el-option label="河南省" value="410000"></el-option> -->
            <!-- <el-option label="湖北省" value="420000"></el-option> -->
            <!-- <el-option label="湖南省" value="430000"></el-option> -->
            <!-- <el-option label="海南省" value="460000"></el-option> -->
            <!-- <el-option label="四川省" value="510000"></el-option> -->
            <!-- <el-option label="贵州省" value="520000"></el-option> -->
            <!-- <el-option label="云南省" value="530000"></el-option> -->
            <!-- <el-option label="陕西省" value="610000"></el-option> -->
            <!-- <el-option label="甘肃省" value="620000"></el-option> -->
            <!-- <el-option label="青海省" value="630000"></el-option> -->
            <!-- <el-option label="台湾省" value="710000"></el-option> -->
            <!-- <el-option label="内蒙古自治区" value="150000"></el-option> -->
            <!-- <el-option label="西藏自治区" value="540000"></el-option> -->
            <!-- <el-option label="宁夏回族自治区" value="640000"></el-option> -->
            <!-- <el-option label="新疆维吾尔自治区" value="650000"></el-option> -->
            <!-- <el-option label="香港" value="810000"></el-option> -->
            <!-- <el-option label="澳门" value="820000"></el-option> -->
            <!-- <el-option label="天津" value="120000"></el-option> -->
            <!-- <el-option label="重庆" value="500000"></el-option> -->
          </el-select>
        </div>
      </div>
      <div class="header-center">
        <h1 class="title">易充云丨运营管理平台</h1>
        <div class="weather-inline">
          <span class="weather-location">{{ currentWeatherCity }}</span>
          <span class="weather-divider">|</span>
          <span class="weather-temp">{{ weatherData.temperature }}°C</span>
          <span class="weather-desc">{{ weatherData.description }}</span>
          <span class="weather-divider">|</span>
          <span class="weather-humidity">湿度 {{ weatherData.humidity }}%</span>
          <span class="weather-divider">|</span>
          <span class="weather-wind">风速 {{ weatherData.windSpeed }}km/h</span>
        </div>
      </div>
      <div class="header-right">
        <div class="filter-group">
          <el-select v-model="viewType" placeholder="按月统计" class="filter-select" popper-class="custom-popper" style="--el-fill-color-blank: transparent;" @change="handleViewTypeChange">
            <el-option label="按日统计" value="day"></el-option>
            <el-option label="按月统计" value="month"></el-option>
            <el-option label="按季度统计" value="quarter"></el-option>
            <el-option label="按年统计" value="year"></el-option>
            <el-option label="全部" value="all"></el-option>
          </el-select>
        </div>
        <div class="filter-group" v-if="viewType !== 'all'">
          <el-date-picker
            v-if="viewType === 'day'"
            v-model="viewDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            class="filter-select date-picker date-range-picker"
            popper-class="custom-popper"
          />
          <el-date-picker
            v-else-if="viewType === 'month'"
            v-model="viewDateRange"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="YYYY-MM"
            class="filter-select date-picker date-range-picker"
            popper-class="custom-popper"
          />
          <div class="year-range-picker" v-else-if="viewType === 'year'">
            <el-date-picker
              v-model="viewDateRange[0]"
              type="year"
              value-format="YYYY"
              placeholder="开始年份"
              class="filter-select date-picker date-range-picker year-picker"
              popper-class="custom-popper"
            />
            <span class="range-separator">至</span>
            <el-date-picker
              v-model="viewDateRange[1]"
              type="year"
              value-format="YYYY"
              placeholder="结束年份"
              class="filter-select date-picker date-range-picker year-picker"
              popper-class="custom-popper"
            />
          </div>
          <quarter-range-picker
            v-else-if="viewType === 'quarter'"
            v-model="viewDateRange"
            placeholder="选择季度范围"
          />
        </div>
        <div class="refresh-group">
          <el-select v-model="refreshTime" class="filter-select refresh-select" popper-class="custom-popper" style="--el-fill-color-blank: transparent;" @change="onRefreshTimeChange">
            <template #prefix>
              <span class="refresh-icon" @click.stop="manualRefresh"></span>
            </template>
            <el-option label="10S" value="10"></el-option>
            <el-option label="15S" value="15"></el-option>
            <el-option label="30S" value="30"></el-option>
            <el-option label="60S" value="60"></el-option>
          </el-select>
        </div>
        <div class="system-info">
          <div class="info-left">
            <div class="info-item tenant-item" :title="tenantName">
              <span class="label">{{ displayTenantName }}</span>
            </div>
            <div class="info-item admin-item">
              <span class="icon"></span>
              <span class="label">{{ adminName }}</span>
            </div>
          </div>
          <div class="datetime">
            <div class="date">{{ currentDate }}</div>
            <div class="time">{{ currentTime }}</div>
            <div class="weekday">{{ currentWeekday }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 左侧面板 -->
      <div class="left-panel">
        <!-- 今日数据统计 -->
        <div class="panel-box panel-stats">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">今日数据统计</span>
            <el-icon class="eye-icon" @click="todayStatsVisible = !todayStatsVisible">
              <View v-if="todayStatsVisible" />
              <Hide v-else />
            </el-icon>
          </div>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-icon">
                <img src="@/assets/images/large/today_icon1.png" alt="充电量" />
              </div>
              <div class="stat-content">
                <div class="stat-label">充电量</div>
                <div class="stat-value scale-animate-wrapper" :class="{ 'scale-increasing': todayStats.chargeAmount.isIncreasing }" :key="'charge-' + todayStats.chargeAmount.value">
                  <span class="scale-value">{{ todayStatsVisible ? formatWithWUnit(todayStats.chargeAmount.value) : '***' }}</span>
                  <span class="stat-unit">度</span>
                  <span class="stat-scale-plus" v-if="todayStatsVisible && todayStats.chargeAmount.isIncreasing && todayStats.chargeAmount.diff > 0">
                    +{{ formatDiff(todayStats.chargeAmount.diff) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <img src="@/assets/images/large/today_icon2.png" alt="单枪充电量" />
              </div>
              <div class="stat-content">
                <div class="stat-label">单枪充电量</div>
                <div class="stat-value scale-animate-wrapper" :class="{ 'scale-increasing': todayStats.singleGunCharge.isIncreasing }" :key="'single-' + todayStats.singleGunCharge.value">
                  <span class="scale-value">{{ todayStatsVisible ? formatSingleGunCharge(todayStats.singleGunCharge.value) : '***' }}</span>
                  <span class="stat-unit">度</span>
                  <span class="stat-scale-plus" v-if="todayStatsVisible && todayStats.singleGunCharge.isIncreasing && todayStats.singleGunCharge.diff > 0">
                    +{{ formatDiff4(todayStats.singleGunCharge.diff) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <img src="@/assets/images/large/today_icon3.png" alt="今日营收" />
              </div>
              <div class="stat-content">
                <div class="stat-label">今日营收</div>
                <div class="stat-value scale-animate-wrapper revenue-value" :class="{ 'scale-increasing': todayStats.todayRevenue.isIncreasing }" :key="'revenue-' + todayStats.todayRevenue.value">
                  <span class="scale-value">{{ todayStatsVisible ? formatRevenue(todayStats.todayRevenue.value) : '***' }}</span>
                  <span class="stat-unit">元</span>
                  <span class="stat-scale-plus" v-if="todayStatsVisible && todayStats.todayRevenue.isIncreasing && todayStats.todayRevenue.diff > 0">
                    +{{ formatDiff(todayStats.todayRevenue.diff) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <img src="@/assets/images/large/today_icon4.png" alt="充电车次" />
              </div>
              <div class="stat-content">
                <div class="stat-label">充电车次</div>
                <div class="stat-value scale-animate-wrapper" :class="{ 'scale-increasing': todayStats.chargeTimes.isIncreasing }" :key="'times-' + todayStats.chargeTimes.value">
                  <span class="scale-value">{{ todayStatsVisible ? formatInteger(todayStats.chargeTimes.value) : '***' }}</span>
                  <span class="stat-unit">次</span>
                  <span class="stat-scale-plus" v-if="todayStatsVisible && todayStats.chargeTimes.isIncreasing && todayStats.chargeTimes.diff > 0">
                    +{{ formatDiffInteger(todayStats.chargeTimes.diff) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 场站排行榜 TOP -->
        <div class="panel-box panel-ranking">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">场站排行榜</span>
          </div>
          <div class="ranking-chart-wrapper">
            <v-chart class="ranking-chart" :option="rankingChartOption" autoresize />
          </div>
        </div>

        <!-- 实时订单 -->
        <div class="panel-box panel-orders">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">实时订单</span>
            <span class="panel-extra">进行中：{{ orderCount }}单</span>
          </div>
          <div class="order-table">
            <div class="order-header">
              <span class="col-select"></span>
              <span class="col-time">时间</span>
              <span class="col-phone">手机号</span>
              <span class="col-station">站桩枪信息</span>
              <span class="col-amount">充电量</span>
            </div>
            <div class="order-body" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
              <div class="order-scroll-wrapper" :class="{ 'scroll-paused': isScrollPaused }">
                <div class="order-row" 
                     v-for="(item, index) in displayOrders" 
                     :key="'order-' + index"
                     :class="{ 'order-row-selected': selectedIndex === index }"
                     @mouseenter="selectOrder(index)"
                     @mouseleave="deselectOrder">
                  <span class="col-select">
                    <img v-if="selectedIndex === index" src="../assets/images/large/select_icon.png" alt="" class="select-icon" />
                  </span>
                  <span class="col-time">{{ item.time }}</span>
                  <span class="col-phone">{{ item.phone }}</span>
                  <span class="col-station" :title="item.station">{{ item.station }}</span>
                  <span class="col-amount">{{ item.amount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间面板 -->
      <div class="center-panel">
        <!-- 规模数据 -->
        <div class="scale-data">
          <!-- 头部：标题靠左 + 充电量 + 记分牌居中 -->
          <div class="scale-header">
            <div class="scale-title-bg">
              <img src="../assets/images/large/title_bg2.png" alt="" class="title-bg-img" />
              <span class="scale-title-text">规模数据</span>
              <el-icon class="eye-icon" @click="scaleDataVisible = !scaleDataVisible">
                <View v-if="scaleDataVisible" />
                <Hide v-else />
              </el-icon>
            </div>
            <div class="charge-display-wrapper">
              <div class="charge-display">
                <span class="charge-label">充电量</span>
                <div class="scale-animate-wrapper" :class="{ 'scale-increasing': chargeAmountIncreasing }">
                  <span class="scale-value">
                    <div class="charge-numbers">
                      <div class="flip-digit" v-for="(item, index) in chargeAmountDisplay" :key="'digit-' + index" :class="{ 'flip-digit-new': item.isNew }">
                        <div class="flip-card">
                          <div class="flip-top">{{ scaleDataVisible ? item.current : '*' }}</div>
                          <div class="flip-bottom">{{ scaleDataVisible ? item.current : '*' }}</div>
                          <div class="flip-top-flip" :class="{ 'flip-animate': item.flipping }">{{ scaleDataVisible ? item.current : '*' }}</div>
                          <div class="flip-bottom-flip" :class="{ 'flip-animate': item.flipping }">{{ scaleDataVisible ? item.current : '*' }}</div>
                        </div>
                      </div>
                      <span class="charge-unit-wan" v-if="isChargeAmountOverMillion">万</span>
                      <span class="charge-unit">度</span>
                    </div>
                  </span>
                  <span class="scale-plus" v-if="chargeAmountIncreasing && chargeAmountDiff > 0">
                    +{{ formatDiff(chargeAmountDiff) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="scale-info">
              <div class="scale-info-line">当前视图：{{ currentViewText }}</div>
              <div class="scale-info-line">数据更新时间：{{ dataUpdateTime }}</div>
            </div>
          </div>

          <!-- 地图容器 -->
          <div class="map-wrapper">
            <!-- 地图顶部悬浮数据：单枪充电量 + 合计营收 + 总车次 -->
            <div class="map-top-data">
              <div class="top-data-item">
                <img src="../assets/images/large/gun_icon.png" alt="" class="data-icon" />
                <div class="data-content">
                  <span class="data-label">单枪充电量：</span>
                  <span class="data-value scale-animate-wrapper" :class="{ 'scale-increasing': scaleData.singleGunCharge.isIncreasing }" :key="'gun-' + scaleData.singleGunCharge.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatSingleGunCharge(scaleData.singleGunCharge.value) : '***' }}</span>
                    <span class="data-unit">度</span>
                    <span class="scale-plus" v-if="scaleDataVisible && scaleData.singleGunCharge.isIncreasing && scaleData.singleGunCharge.diff > 0">
                      +{{ formatDiff4(scaleData.singleGunCharge.diff) }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="top-data-item">
                <img src="../assets/images/large/revenue_icon.png" alt="" class="data-icon" />
                <div class="data-content">
                  <span class="data-label">合计营收：</span>
                  <span class="data-value scale-animate-wrapper" :class="{ 'scale-increasing': scaleData.totalRevenue.isIncreasing }" :key="'revenue-' + scaleData.totalRevenue.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatRevenue(scaleData.totalRevenue.value) : '***' }}</span>
                    <span class="data-unit">元</span>
                    <span class="scale-plus" v-if="scaleDataVisible && scaleData.totalRevenue.isIncreasing && scaleData.totalRevenue.diff > 0">
                      +{{ formatDiff(scaleData.totalRevenue.diff) }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="top-data-item">
                <img src="../assets/images/large/cai_icon.png" alt="" class="data-icon" />
                <div class="data-content">
                  <span class="data-label">总车次：</span>
                  <span class="data-value scale-animate-wrapper" :class="{ 'scale-increasing': scaleData.totalTimes.isIncreasing }" :key="'times-' + scaleData.totalTimes.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(scaleData.totalTimes.value) : '***' }}</span>
                    <span class="data-unit">次</span>
                    <span class="scale-plus" v-if="scaleDataVisible && scaleData.totalTimes.isIncreasing && scaleData.totalTimes.diff > 0">
                      +{{ formatDiffInteger(scaleData.totalTimes.diff) }}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <!-- 地图导航面包屑 -->
            <div class="map-breadcrumb" v-if="mapLevel !== 'china'">
              <span class="breadcrumb-item clickable" @click="backToChinaMap">全国</span>
              <span class="breadcrumb-separator">/</span>
              <span class="breadcrumb-item" v-if="mapLevel === 'province'">{{ currentProvince }}</span>
              <template v-if="mapLevel === 'city'">
                <span class="breadcrumb-item clickable" @click="backToProvinceMap">{{ currentProvince }}</span>
                <span class="breadcrumb-separator">/</span>
                <span class="breadcrumb-item">{{ currentCity }}</span>
              </template>
            </div>

            <!-- 地图区域 -->
            <div class="map-container">
              <v-chart ref="mapChart" class="china-map" :key="currentMapRegion" :option="mapOption" :autoresize="true" @click="handleMapClick" />
            </div>

            <!-- 地图下方悬浮数据：运营场站 + 快充枪 + 慢充枪 + 注册用户 + 在建场站 + 在建快充枪 + 在建慢充枪 -->
            <div class="map-footer-data">
              <div class="footer-data-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_data_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.stationCount.isIncreasing }" :key="'station-' + mapStats.stationCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.stationCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.stationCount.isIncreasing && mapStats.stationCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.stationCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">运营场站</span>
              </div>
              <div class="footer-data-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_data_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.fastGunCount.isIncreasing }" :key="'fast-' + mapStats.fastGunCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.fastGunCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.fastGunCount.isIncreasing && mapStats.fastGunCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.fastGunCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">快充枪数量(个)</span>
              </div>
              <div class="footer-data-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_data_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.slowGunCount.isIncreasing }" :key="'slow-' + mapStats.slowGunCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.slowGunCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.slowGunCount.isIncreasing && mapStats.slowGunCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.slowGunCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">慢充枪数量(个)</span>
              </div>
              <div class="footer-data-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_data_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.userCount.isIncreasing }" :key="'user-' + mapStats.userCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.userCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.userCount.isIncreasing && mapStats.userCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.userCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">注册用户(个)</span>
              </div>
              <div class="footer-data-item build-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_build_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.buildStationCount.isIncreasing }" :key="'build-station-' + mapStats.buildStationCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.buildStationCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.buildStationCount.isIncreasing && mapStats.buildStationCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.buildStationCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">在建场站数量(个)</span>
              </div>
              <div class="footer-data-item build-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_build_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.buildFastGunCount.isIncreasing }" :key="'build-fast-' + mapStats.buildFastGunCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.buildFastGunCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.buildFastGunCount.isIncreasing && mapStats.buildFastGunCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.buildFastGunCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">在建快充枪数量(个)</span>
              </div>
              <div class="footer-data-item build-item">
                <div class="footer-value-bg">
                  <img src="../assets/images/large/map_footer_build_bg.png" alt="" class="footer-bg-img" />
                  <span class="footer-value scale-animate-wrapper" :class="{ 'scale-increasing': mapStats.buildSlowGunCount.isIncreasing }" :key="'build-slow-' + mapStats.buildSlowGunCount.value">
                    <span class="scale-value">{{ scaleDataVisible ? formatInteger(mapStats.buildSlowGunCount.value) : '***' }}</span>
                    <span class="scale-plus" v-if="scaleDataVisible && mapStats.buildSlowGunCount.isIncreasing && mapStats.buildSlowGunCount.diff > 0">
                      +{{ formatDiffInteger(mapStats.buildSlowGunCount.diff) }}
                    </span>
                  </span>
                </div>
                <span class="footer-label">在建慢充枪数量(个)</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 尖峰平谷充电量 -->
        <div class="panel-box panel-peak-valley">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">尖峰平谷充电量</span>
          </div>
          <div class="chart-container">
            <div class="chart-legend">
              <span class="legend-item"><span class="legend-color" style="background: #ff4d4f;"></span>尖段占比{{ peakValleyData.peakRate.toFixed(2) }}%</span>
              <span class="legend-item"><span class="legend-color" style="background: #1890ff;"></span>峰段占比{{ peakValleyData.highRate.toFixed(2) }}%</span>
              <span class="legend-item"><span class="legend-color" style="background: #faad14;"></span>平段占比{{ peakValleyData.flatRate.toFixed(2) }}%</span>
              <span class="legend-item"><span class="legend-color" style="background: #52c41a;"></span>谷段占比{{ peakValleyData.valleyRate.toFixed(2) }}%</span>
            </div>
            <v-chart class="peak-valley-chart" :option="peakValleyChartOption" autoresize />
          </div>
        </div>
      </div>

      <!-- 右侧面板 -->
      <div class="right-panel">
        <!-- 设备利用率 -->
        <div class="panel-box panel-utilization">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">设备利用率</span>
          </div>
          <div class="utilization-grid">
            <div class="utilization-item">
              <div class="utilization-bg">
                <div class="utilization-icon">
                  <img src="@/assets/images/large/slow.png" alt="慢充" />
                </div>
                <div class="utilization-content">
                  <div class="utilization-label">时间利用率</div>
                  <div class="utilization-value">{{ utilizationData.slowTimeUtilizationRate }}%</div>
                  <div class="utilization-label">功率利用率</div>
                  <div class="utilization-value">{{ utilizationData.slowPowerUtilizationRate }}%</div>
                </div>
              </div>
            </div>
            <div class="utilization-item">
              <div class="utilization-bg">
                <div class="utilization-icon">
                  <img src="@/assets/images/large/fast.png" alt="快充" />
                </div>
                <div class="utilization-content">
                  <div class="utilization-label">时间利用率</div>
                  <div class="utilization-value">{{ utilizationData.fastTimeUtilizationRate }}%</div>
                  <div class="utilization-label">功率利用率</div>
                  <div class="utilization-value">{{ utilizationData.fastPowerUtilizationRate }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 设备实时状态 -->
        <div class="panel-box panel-device-status">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">设备实时状态</span>
          </div>
          <div class="device-status-chart">
            <v-chart class="device-status-echarts" :option="deviceStatusChartOption" autoresize />
            <div class="device-status-legend">
              <div class="legend-item" v-for="cat in ['使用中', '空闲', '离线', '故障']" :key="cat">
                <span class="legend-color" :class="'color-' + cat"></span>
                <span class="legend-text">{{ cat }}</span>
                <div class="legend-detail">
                  <span>慢充：{{ statusDataMap[cat].slowCount }}台</span>
                  <span>快充：{{ statusDataMap[cat].fastCount }}台</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 实时告警 -->
        <div class="panel-box panel-alarm">
          <div class="panel-title">
            <span class="title-icon"></span>
            <span class="title-text">实时告警</span>
            <span class="panel-extra">待处理：{{ alarmCount }}</span>
          </div>
          <div class="alarm-table">
            <div class="alarm-header">
              <span class="col-select"></span>
              <span class="col-time">时间</span>
              <span class="col-device">站桩枪信息</span>
              <span class="col-name">告警名称</span>
              <span class="col-status">告警状态</span>
            </div>
            <div class="alarm-body" @mouseenter="pauseAlarmScroll" @mouseleave="resumeAlarmScroll">
              <div class="alarm-scroll-wrapper" :class="{ 'scroll-paused': isAlarmScrollPaused }">
                <div class="alarm-row" 
                     v-for="(item, index) in displayAlarms" 
                     :key="'alarm-' + index"
                     :class="{ 'alarm-row-selected': selectedAlarmIndex === index, 'alarm-unhandled-row': item.status === '未处理' }"
                     @mouseenter="selectAlarm(index)"
                     @mouseleave="deselectAlarm">
                  <span class="col-select">
                    <img v-if="selectedAlarmIndex === index" src="../assets/images/large/select_icon.png" alt="" class="select-icon" />
                  </span>
                  <span class="col-time">{{ item.time }}</span>
                  <span class="col-device" :title="item.device">{{ item.device }}</span>
                  <span class="col-name" :title="item.name">{{ item.name }}</span>
                  <span class="col-status" :class="item.status === '未处理' ? 'status-pending' : 'status-handled'">{{ item.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import QuarterPicker from '../components/QuarterPicker.vue';
import QuarterRangePicker from '../components/QuarterRangePicker.vue';
import VChart from 'vue-echarts';

export default {
  name: 'LargeScreen',
  components: {
    QuarterPicker,
    QuarterRangePicker,
    VChart
  },
  data() {
    return {
      currentTime: '',
      currentDate: '',
      currentWeekday: '',
      adminName: localStorage.getItem('SAAS_USERNAME') || '管理员',
      systemTime: '',
      timeTimer: null,
      dataUpdateTime: '',
      stationType: '',
      region: localStorage.getItem('provinceCode') || '',
      province: localStorage.getItem('province') || '',
      provinceCode: localStorage.getItem('provinceCode') || '',
      viewType: 'month',
      viewDateRange: [],
      refreshTime: '10',
      todayStatsVisible: false,
      scaleDataVisible: false,
      todayStats: {
        chargeAmount: { value: '0.00', diff: 0, isIncreasing: false },
        singleGunCharge: { value: '0.00', diff: 0, isIncreasing: false },
        todayRevenue: { value: '0.00', diff: 0, isIncreasing: false },
        chargeTimes: { value: '0', diff: 0, isIncreasing: false }
      },
      stationRanking: [],
      orderCount: 0,
      realTimeOrders: [],
      selectedIndex: -1, // 当前选中的订单索引
      isScrollPaused: false, // 是否暂停滚动
      scrollTimer: null, // 滚动定时器
      refreshTimer: null, // 定时刷新定时器
      scaleData: {
        totalRevenue: { value: '0', diff: 0, isIncreasing: false },
        singleGunCharge: { value: '0', diff: 0, isIncreasing: false },
        totalTimes: { value: '0', diff: 0, isIncreasing: false }
      },
      totalElecValue: '0.00', // 存储总充电量原始值
      totalElecRawValue: 0, // 存储总充电量原始值（未转换单位）
      chargeAmountIncreasing: false, // 充电量增长动效标志
      chargeAmountDiff: 0, // 充电量增长差值
      chargeAmountDisplay: [
        { current: '0', next: '0', flipping: false }
      ],
      mapStats: {
        stationCount: { value: '0', diff: 0, isIncreasing: false },
        fastGunCount: { value: '0', diff: 0, isIncreasing: false },
        slowGunCount: { value: '0', diff: 0, isIncreasing: false },
        userCount: { value: '0', diff: 0, isIncreasing: false },
        buildStationCount: { value: '0', diff: 0, isIncreasing: false },
        buildFastGunCount: { value: '0', diff: 0, isIncreasing: false },
        buildSlowGunCount: { value: '0', diff: 0, isIncreasing: false }
      },
      // 地图相关
      currentMapRegion: 'china', // 当前显示的地图区域
      mapLevel: 'china', // 当前地图级别: china/province/city
      currentProvince: '', // 当前省份名称
      currentCity: '', // 当前城市名称
      currentProvinceCode: '', // 当前省份代码
      mapRegionMap: null, // 区域代码到地图名称的映射
      mapChartInstance: null, // 地图图表实例
      mapData: {}, // 存储各区域的地图数据
      mapLoaded: false, // 地图数据是否已加载
      mapElecData: {}, // 存储地图电量数据 { 区域名: { gunCount: 充电枪数, stationCount: 充电站数, chargeAmount: 充电量 } }
      mapDataRequestId: 0, // 地图数据请求ID，用于追踪最新请求
      codeToNameMap: {}, // 存储代码到名称的映射（用于省份地图）
      mapUserState: { zoom: null, center: null }, // 保存用户的缩放和位移状态
      mapInitialized: false, // 标记地图是否已初始化（用于控制是否设置初始zoom/center）
      mapFirstLoad: true, // 标记是否为首次加载地图（用于控制是否设置初始zoom/center）
      provinceGeoJsonCache: {}, // 缓存省份GeoJSON数据
      cityGeoJsonCache: {}, // 缓存城市GeoJSON数据
      deviceStatusData: {
        totalCount: 0,
        idleData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        chargeData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        offlineData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        faultData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 }
      },
      alarmCount: 0,
      alarmList: [],
      selectedAlarmIndex: -1,
      isAlarmScrollPaused: false,
      alarmScrollTimer: null,
      // 设备利用率数据
      utilizationData: {
        fastTimeUtilizationRate: 0,
        fastPowerUtilizationRate: 0,
        slowTimeUtilizationRate: 0,
        slowPowerUtilizationRate: 0
      },
      // 尖峰平谷数据
      peakValleyData: {
        peakRate: 0,
        highRate: 0,
        flatRate: 0,
        valleyRate: 0,
        chargingHourDatas: []
      },
      // 尖峰平谷图表配置
      peakValleyChartOption: {},
      chargeTimer: null,
      isInitialized: false, // 标记是否已完成初始化
      _isMounted: false, // 标记组件是否已挂载
      // 天气数据
      weatherData: {
        temperature: '--',
        description: '加载中...',
        humidity: '--',
        windSpeed: '--'
      },
      weatherTimer: null, // 天气刷新定时器
      // 省份/直辖市代码到城市名称和经纬度的映射
      provinceWeatherMap: {
        '': { name: '北京', latitude: 39.9042, longitude: 116.4074 }, // 全国 - 显示首都
        '440000': { name: '广州', latitude: 23.1291, longitude: 113.2644 },
        '350000': { name: '福州', latitude: 26.0745, longitude: 119.2965 },
        '340000': { name: '合肥', latitude: 31.8206, longitude: 117.2272 },
        '450000': { name: '南宁', latitude: 22.8170, longitude: 108.3665 },
        '330000': { name: '杭州', latitude: 30.2741, longitude: 120.1551 },
        '320000': { name: '南京', latitude: 32.0603, longitude: 118.7969 },
        '110000': { name: '北京', latitude: 39.9042, longitude: 116.4074 },
        '310000': { name: '上海', latitude: 31.2304, longitude: 121.4737 }
      },
      currentWeatherCity: '北京' // 当前显示天气的城市
    }
  },
  mounted() {
    this._isMounted = true;
    // 先设置时间默认值，确保初始化地图时已有时间参数
    this.setViewDateDefault();
    this.initCharts();
    this.bindMapEvents();
    this.startAutoScroll();
    // 移除定时翻牌动画，只在数据更新时翻牌
    // this.startChargeAmountAnimation();
    this.fetchTodayMetrics();
    this.fetchScaleData();
    this.fetchStationRanking();
    this.fetchRealtimeOrders();
    this.fetchPeakValleyData();
    this.fetchUtilizationRate();
    this.fetchRealTimeStatus();
    this.fetchRealtimeAlarms();
    this.updateTime();
    this.fetchWeather(); // 获取天气数据
    this.timeTimer = setInterval(() => {
      this.updateTime();
    }, 1000);
    // 监听全屏状态变化
    this.checkFullscreen();
    window.addEventListener('resize', this.checkFullscreen);
    document.addEventListener('fullscreenchange', this.checkFullscreen);
    document.addEventListener('webkitfullscreenchange', this.checkFullscreen);
    document.addEventListener('mozfullscreenchange', this.checkFullscreen);
    document.addEventListener('MSFullscreenChange', this.checkFullscreen);
    // 标记初始化完成
    this.$nextTick(() => {
      this.isInitialized = true;
      // 初始化翻牌显示的测试数据
      this.updateChargeAmountDisplay(this.totalElecValue);
    });
    // 启动定时刷新
    this.startRefreshTimer();
  },
  watch: {
    stationType() {
      this.fetchTodayMetrics();
      this.fetchScaleData();
      this.fetchStationRanking();
      this.fetchRealtimeOrders();
      this.fetchPeakValleyData();
      this.fetchUtilizationRate();
      this.fetchRealTimeStatus();
      this.fetchRealtimeAlarms();
      // 切换场站类型时刷新地图数据
      this.fetchMapData(this.provinceCode);
    },
    region(newVal) {
      // 检查组件是否仍然存在
      if (!this._isMounted) return;
      
      this.provinceCode = newVal;
      // 根据选择的区域代码更新省份名称
      const regionMap = {
        '440000': '广东省',
        '350000': '福建省',
        '340000': '安徽省',
        '450000': '广西省',
        '330000': '浙江省',
        '320000': '江苏省',
        '110000': '北京',
        '310000': '上海'
      };
      this.province = regionMap[newVal] || '全国';
      
      // 切换地图级别时重置用户的缩放和位移状态，恢复初始状态
      this.mapUserState = { zoom: null, center: null };
      this.mapFirstLoad = true; // 重置首次加载标记
      this.mapInitialized = false;
      
      // 根据选择的区域切换地图
      // 中文省份名到英文文件名的映射
      const provinceNameMap = {
        '广东省': 'guangdong',
        '福建省': 'fujian',
        '安徽省': 'anhui',
        '广西省': 'guangxi',
        '浙江省': 'zhejiang',
        '江苏省': 'jiangsu',
        '北京': 'beijing',
        '上海': 'shanghai'
      };
      
      if (newVal) {
        const provinceName = regionMap[newVal];
        const englishName = provinceNameMap[provinceName];
        if (englishName) {
          const provinceUrl = `https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/province/${englishName}.json`;
          this.mapLevel = 'province'; // 更新地图级别
          this.currentProvince = provinceName;
          this.currentProvinceCode = newVal;
          // 使用 loadProvinceMap 确保与初次加载和下钻逻辑一致
          this.loadProvinceMap(provinceName, provinceUrl, () => {
            // 地图加载成功后的回调
            if (!this._isMounted) return;
            this.currentMapRegion = provinceName;
          });
        }
      } else {
        // 选择全国时返回全国地图
        this.mapLevel = 'china'; // 更新地图级别
        // 注意：currentProvince 和 currentMapRegion 会在 loadMapData 成功后设置
        this.loadMapData('china', 'https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/china.json', () => {
          // 地图加载成功后的回调
          if (!this._isMounted) return;
          this.currentProvince = '';
          this.currentMapRegion = 'china';
        });
      }
      
      this.fetchTodayMetrics();
      this.fetchScaleData();
      this.fetchStationRanking();
      this.fetchRealtimeOrders();
      this.fetchPeakValleyData();
      this.fetchUtilizationRate();
      this.fetchRealTimeStatus();
      this.fetchRealtimeAlarms();
      this.fetchWeather(); // 切换区域时刷新天气数据
      // 切换区域时刷新地图数据
      this.fetchMapData(newVal);
    },
    viewDateRange() {
      // 初始化完成前不触发，避免重复请求
      if (!this.isInitialized) return;
      // 切换时间范围时刷新地图数据
      this.fetchMapData(this.provinceCode);
      this.fetchScaleData();
      this.fetchStationRanking();
      this.fetchRealtimeOrders();
      this.fetchPeakValleyData();
    }
  },
  computed: {
    isChargeAmountOverMillion() {
      return this.totalElecRawValue >= 1000000;
    },
    statusDataMap() {
      return {
        '使用中': this.deviceStatusData.chargeData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        '空闲': this.deviceStatusData.idleData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        '离线': this.deviceStatusData.offlineData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
        '故障': this.deviceStatusData.faultData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 }
      };
    },
    tenantName() {
      return localStorage.getItem('tenantName') || '';
    },
    displayTenantName() {
      const name = this.tenantName;
      if (name.length > 5) {
        return name.substring(0, 5) + '...';
      }
      return name;
    },
    currentViewText() {
      const regionText = this.province || '全国';
      let stationTypeText = '全部场站类型';
      if (this.stationType === 1) {
        stationTypeText = '高速场站类型';
      } else if (this.stationType === 2) {
        stationTypeText = '市区场站类型';
      } else if (this.stationType === 3) {
        stationTypeText = '内部场站类型';
      } else if (this.stationType === 4) {
        stationTypeText = '社区场站类型';
      }
      return `${regionText}/${stationTypeText}`;
    },
    displayOrders() {
      // 将订单数据复制一份用于走马灯循环滚动，只有多于5条数据时才复制
      if (this.realTimeOrders.length <= 5) {
        return [...this.realTimeOrders];
      }
      return [...this.realTimeOrders, ...this.realTimeOrders];
    },
    displayAlarms() {
      // 将告警数据复制一份用于走马灯循环滚动，只有多于5条数据时才复制
      if (this.alarmList.length <= 5) {
        return [...this.alarmList];
      }
      return [...this.alarmList, ...this.alarmList];
    },
    mapOption() {
      if (!this.mapLoaded || !this.currentMapRegion) {
        return {};
      }
      
      // 确保依赖 mapElecData，触发响应式更新
      const _mapElecData = this.mapElecData;
      const mapName = this.currentMapRegion;
      const isCityMap = this.mapLevel === 'city';
      

      
      // 根据当前地图类型决定省份数据
      let provinces = [];
      if (mapName === 'china') {
        // 全国地图使用接口返回的数据
        provinces = [
          { name: '新疆', value: (this.mapElecData['新疆'] && this.mapElecData['新疆'].gunCount) || 0 },
          { name: '西藏', value: (this.mapElecData['西藏'] && this.mapElecData['西藏'].gunCount) || 0 },
          { name: '青海', value: (this.mapElecData['青海'] && this.mapElecData['青海'].gunCount) || 0 },
          { name: '甘肃', value: (this.mapElecData['甘肃'] && this.mapElecData['甘肃'].gunCount) || 0 },
          { name: '内蒙古', value: (this.mapElecData['内蒙古'] && this.mapElecData['内蒙古'].gunCount) || 0 },
          { name: '宁夏', value: (this.mapElecData['宁夏'] && this.mapElecData['宁夏'].gunCount) || 0 },
          { name: '黑龙江', value: (this.mapElecData['黑龙江'] && this.mapElecData['黑龙江'].gunCount) || 0 },
          { name: '吉林', value: (this.mapElecData['吉林'] && this.mapElecData['吉林'].gunCount) || 0 },
          { name: '辽宁', value: (this.mapElecData['辽宁'] && this.mapElecData['辽宁'].gunCount) || 0 },
          { name: '河北', value: (this.mapElecData['河北'] && this.mapElecData['河北'].gunCount) || 0 },
          { name: '北京', value: (this.mapElecData['北京'] && this.mapElecData['北京'].gunCount) || 0 },
          { name: '天津', value: (this.mapElecData['天津'] && this.mapElecData['天津'].gunCount) || 0 },
          { name: '山西', value: (this.mapElecData['山西'] && this.mapElecData['山西'].gunCount) || 0 },
          { name: '陕西', value: (this.mapElecData['陕西'] && this.mapElecData['陕西'].gunCount) || 0 },
          { name: '山东', value: (this.mapElecData['山东'] && this.mapElecData['山东'].gunCount) || 0 },
          { name: '河南', value: (this.mapElecData['河南'] && this.mapElecData['河南'].gunCount) || 0 },
          { name: '江苏', value: (this.mapElecData['江苏'] && this.mapElecData['江苏'].gunCount) || 0 },
          { name: '安徽', value: (this.mapElecData['安徽'] && this.mapElecData['安徽'].gunCount) || 0 },
          { name: '浙江', value: (this.mapElecData['浙江'] && this.mapElecData['浙江'].gunCount) || 0 },
          { name: '上海', value: (this.mapElecData['上海'] && this.mapElecData['上海'].gunCount) || 0 },
          { name: '湖北', value: (this.mapElecData['湖北'] && this.mapElecData['湖北'].gunCount) || 0 },
          { name: '湖南', value: (this.mapElecData['湖南'] && this.mapElecData['湖南'].gunCount) || 0 },
          { name: '江西', value: (this.mapElecData['江西'] && this.mapElecData['江西'].gunCount) || 0 },
          { name: '福建', value: (this.mapElecData['福建'] && this.mapElecData['福建'].gunCount) || 0 },
          { name: '广东', value: (this.mapElecData['广东'] && this.mapElecData['广东'].gunCount) || 0 },
          { name: '广西', value: (this.mapElecData['广西'] && this.mapElecData['广西'].gunCount) || 0 },
          { name: '海南', value: (this.mapElecData['海南'] && this.mapElecData['海南'].gunCount) || 0 },
          { name: '四川', value: (this.mapElecData['四川'] && this.mapElecData['四川'].gunCount) || 0 },
          { name: '重庆', value: (this.mapElecData['重庆'] && this.mapElecData['重庆'].gunCount) || 0 },
          { name: '贵州', value: (this.mapElecData['贵州'] && this.mapElecData['贵州'].gunCount) || 0 },
          { name: '云南', value: (this.mapElecData['云南'] && this.mapElecData['云南'].gunCount) || 0 },
          { name: '台湾', value: 0 },
          { name: '南海诸岛', value: 0 }
        ];
      } else {
        // 省份地图或城市地图：根据地图features生成各区域的数据
        const mapJson = echarts.getMap(mapName);
        if (mapJson && mapJson.geoJson && mapJson.geoJson.features) {
          mapJson.geoJson.features.forEach(feature => {
            const name = feature.properties.name;
            const data = this.mapElecData[name] || {};
            provinces.push({ name, value: data.gunCount || 0 });
          });
        }
      }

      // 省份地图的缩放和中心点配置
      const provinceConfig = {
        '海南': { zoom: 6, center: [109.8, 19.2] },
        '广东省': { zoom: 1.5, center: [113.6, 22.8] },
        '广东': { zoom: 1.5, center: [113.6, 22.8] },
        '福建省': { zoom: 1.5, center: [118.5, 25.5] },
        '福建': { zoom: 1.5, center: [118.5, 25.5] },
        '广西省': { zoom: 1.2, center: [108.5, 23.5] },
        '广西': { zoom: 1.2, center: [108.5, 23.5] },
        '广西壮族自治区': { zoom: 1.2, center: [108.5, 23.5] },
        '浙江省': { zoom: 1.2, center: [120.5, 29.5] },
        '浙江': { zoom: 1.2, center: [120.5, 29.5] },
        '江苏省': { zoom: 1.2, center: [120.5, 33.5] },
        '江苏': { zoom: 1.2, center: [120.5, 33.5] },
        '安徽省': { zoom: 1.2, center: [117.5, 32] },
        '安徽': { zoom: 1.2, center: [117.5, 32] },
        '北京市': { zoom: 1.5, center: [116.4, 40.1] },
        '北京': { zoom: 1.5, center: [116.4, 40.1] },
        '上海市': { zoom: 1.5, center: [121.5, 31.2] },
        '上海': { zoom: 1.5, center: [121.5, 31.2] }
      };

      // 尝试直接匹配，如果不匹配则尝试去掉"省"字后匹配
      let config = provinceConfig[mapName];
      if (!config) {
        const mapNameWithoutSuffix = mapName.replace(/省$/, '').replace(/壮族自治区$/, '').replace(/特别行政区$/, '');
        config = provinceConfig[mapNameWithoutSuffix];
      }
      if (!config) {
        config = { zoom: 1.5, center: undefined };
      }
      
      // 城市地图使用更大的缩放比例
      const finalZoom = isCityMap ? 1.2 : (mapName === 'china' ? 1.2 : (config.zoom || 1.5));
      let finalCenter = undefined;
      if (!isCityMap) {
        if (mapName === 'china') {
          finalCenter = [104.5, 34.5];
        } else if (config.center && Array.isArray(config.center) && config.center.length === 2) {
          finalCenter = config.center;
        }
      }

      // 动态计算 visualMap 的最大值
      const values = provinces.map(p => p.value);
      const maxVal = Math.max(...values, 1);

      // 构建涟漪散点数据
      const scatterData = [];
      provinces.forEach(province => {
        if (province.value > 0) {
          const center = this.getRegionCenter(province.name);
          if (center) {
            const regionData = _mapElecData[province.name] || {};
            scatterData.push({
              name: province.name,
              value: [center[0], center[1], regionData.stationCount || 0],
              stationCount: regionData.stationCount || 0
            });
          }
        }
      });

      // 判断是否使用用户状态还是初始状态
      const useUserState = !this.mapFirstLoad && this.mapUserState.zoom !== null;

      return {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#1890ff',
          textStyle: { color: '#fff' },
          formatter: function(params) {
            const regionData = _mapElecData[params.name] || {};
            const gunCount = regionData.gunCount || 0;
            const stationCount = regionData.stationCount || 0;
            const chargeAmount = regionData.chargeAmount || 0;
            
            let tip = '<div style="font-weight:bold;margin-bottom:5px;">' + params.name + '</div>';
            tip += '<div>充电站数：<span style="color:#67C23A;">' + stationCount + '</span> 个</div>';
            tip += '<div>充电枪数：<span style="color:#409EFF;">' + gunCount + '</span> 个</div>';
            tip += '<div>充电量：<span style="color:#E6A23C;">' + chargeAmount + '</span> kWh</div>';
            return tip;
          }
        },
        geo: {
          map: mapName,
          roam: true,
          zoom: useUserState ? this.mapUserState.zoom : finalZoom,
          center: useUserState ? this.mapUserState.center : finalCenter,
          scaleLimit: {
            min: 0.5,
            max: 10
          },
          label: {
            show: true,
            color: '#fff',
            fontSize: isCityMap ? 11 : (mapName === 'china' ? 10 : 12),
            position: isCityMap ? 'inside' : undefined,
            avoidLabelOverlap: !isCityMap,
            labelLayout: function(params) {
              // 上海地图标签偏移配置（使用更大的偏移量）
              const shanghaiLabelOffset = {
                '杨浦区': [0, -50],
                '浦东新区': [80, 40],
                '虹口区': [0, -40],
                '静安区': [0, -40],
                '长宁区': [-50, 0],
                '黄浦区': [0, 40],
                '普陀区': [0, -40],
                '徐汇区': [-40, 40],
                '闵行区': [0, 50],
                '宝山区': [0, -40],
                '嘉定区': [-40, -40],
                '松江区': [-40, 40],
                '青浦区': [-60, 0],
                '奉贤区': [0, 40],
                '金山区': [-40, 40]
              };
              
              // 北京地图标签偏移配置（使用更大的偏移量）
              const beijingLabelOffset = {
                '门头沟区': [-60, 0],
                '海淀区': [-40, -40],
                '朝阳区': [50, -40],
                '东城区': [0, 40],
                '西城区': [-40, 40],
                '丰台区': [0, 50],
                '石景山区': [-50, 0],
                '房山区': [0, 50],
                '通州区': [50, 0],
                '顺义区': [40, -40],
                '昌平区': [0, -40],
                '大兴区': [0, 40],
                '怀柔区': [40, -50],
                '平谷区': [60, 0],
                '密云区': [40, -40],
                '延庆区': [-40, -50]
              };
              
              const isShanghai = mapName === '上海市' || mapName === '上海';
              const isBeijing = mapName === '北京市' || mapName === '北京';
              
              if (isShanghai || isBeijing) {
                const labelOffset = isShanghai ? shanghaiLabelOffset : beijingLabelOffset;
                if (labelOffset[params.name]) {
                  const offset = labelOffset[params.name];
                  return {
                    x: params.rect.x + params.rect.width / 2 + offset[0],
                    y: params.rect.y + params.rect.height / 2 + offset[1],
                    moveOverlap: false,
                    hideOverlap: false
                  };
                }
              }
              
              // 城市地图的杨浦区特殊处理
              if (isCityMap && params.name === '杨浦区') {
                return {
                  y: params.rect.y - 15,
                  moveOverlap: false,
                  hideOverlap: false
                };
              }
              
              // 默认布局
              if (isCityMap) {
                return {
                  moveOverlap: false,
                  hideOverlap: false,
                  draggable: true
                };
              }
              
              return {
                hideOverlap: true,
                moveOverlap: 'shiftY',
                draggable: true
              };
            }
          },
          emphasis: {
            label: { show: true, color: '#fff' },
            itemStyle: {
              areaColor: '#4a8ae0'
            }
          },
          itemStyle: {
            areaColor: 'transparent',
            borderColor: '#1a3a6a',
            borderWidth: 1
          },
          select: {
            itemStyle: {
              areaColor: '#4a8ae0'
            }
          }
        },
        visualMap: {
          min: 0,
          max: maxVal,
          geoIndex: 0,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          textStyle: { color: '#fff' },
          inRange: {
            color: ['#1067B3', '#0C86CC', '#07AAE6', '#56CAF5', '#96E3FF']
          },
          outOfRange: {
            color: '#1a5fb4'
          },
          show: false
        },
        series: [{
          name: '充电量',
          type: 'map',
          map: mapName,
          geoIndex: 0,
          data: provinces,
          label: {
            show: true,
            color: '#fff',
            fontSize: isCityMap ? 11 : (mapName === 'china' ? 10 : 12),
            position: isCityMap ? 'inside' : undefined,
            offset: isCityMap ? function(params) {
              // 为杨浦区标签添加向上偏移
              if (params.name === '杨浦区') {
                return [0, -20];
              }
              // 为浦东新区标签添加向下偏移
              if (params.name === '浦东新区') {
                return [0, 30];
              }
              return [0, 0];
            } : undefined,
            labelLayout: isCityMap ? {
              moveOverlap: false,
              hideOverlap: false,
              draggable: true
            } : {
              hideOverlap: true,
              moveOverlap: 'shiftY',
              draggable: true
            }
          },
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#1890ff',
            textStyle: { color: '#fff' },
            formatter: function(params) {
              const regionData = _mapElecData[params.name] || {};
              const gunCount = regionData.gunCount || 0;
              const stationCount = regionData.stationCount || 0;
              const chargeAmount = regionData.chargeAmount || 0;
              
              let tip = '<div style="font-weight:bold;margin-bottom:5px;">' + params.name + '</div>';
              tip += '<div>充电站数：<span style="color:#67C23A;">' + stationCount + '</span> 个</div>';
              tip += '<div>充电枪数：<span style="color:#409EFF;">' + gunCount + '</span> 个</div>';
              tip += '<div>充电量：<span style="color:#E6A23C;">' + chargeAmount + '</span> kWh</div>';
              return tip;
            }
          }
        }, {
          name: '充电站数',
          type: 'effectScatter',
          coordinateSystem: 'geo',
          symbolSize: function(val) {
            const count = val[2];
            return Math.min(Math.max(20, Math.sqrt(count) * 3), 50);
          },
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke',
            scale: 3,
            period: 4
          },
          label: {
            show: true,
            formatter: function(param) {
              return param.data.stationCount || 0;
            },
            position: 'inside',
            color: '#fff',
            fontSize: 12,
            fontWeight: 'bold'
          },
          itemStyle: {
            color: '#00d4ff',
            borderColor: '#1FDAFF',
            borderWidth: 2,
            shadowBlur: 10,
            shadowColor: '#333'
          },
          zlevel: 1,
          data: scatterData
        }]
      };
    },
    rankingChartOption() {
      if (!this.stationRanking || this.stationRanking.length === 0) {
        return {};
      }
      
      // 取前10个场站
      const topStations = this.stationRanking.slice(0, 10);
      const stationNames = topStations.map(item => {
        const name = item.stationName || '';
        return name.length > 2 ? name.substring(0, 2) + '...' : name;
      });
      const chargeCounts = topStations.map(item => item.chargeCount || 0);
      const elecValues = topStations.map(item => item.elec || 0);
      
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(0, 20, 40, 0.9)',
          borderColor: '#00d4ff',
          textStyle: {
            color: '#fff'
          },
          formatter: function(params) {
            // 获取完整场站名称
            const fullStationName = topStations[params[0].dataIndex]?.stationName || params[0].name;
            let result = fullStationName + '<br/>';
            params.forEach(item => {
              if (item.seriesName === '充电车次') {
                result += item.marker + item.seriesName + '：' + item.value + '次<br/>';
              } else if (item.seriesName === '充电量') {
                result += item.marker + item.seriesName + '：' + item.value + 'kWh<br/>';
              }
            });
            return result;
          }
        },
        legend: {
          data: ['充电车次', '充电量'],
          top: 0,
          left: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 20
        },
        grid: {
          left: '6%',
          right: '8%',
          bottom: '5%',
          top: '35',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: stationNames,
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 11,
            interval: 0,
            rotate: 0
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.05)',
              type: 'dashed'
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '车次',
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: 11
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: 11
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.08)',
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: 11
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: 11
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '充电车次',
            type: 'bar',
            yAxisIndex: 0,
            data: chargeCounts,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00aaff' },
                { offset: 1, color: '#0066ff' }
              ]),
              borderRadius: [2, 2, 0, 0]
            },
            barWidth: '30%',
            barGap: '20%'
          },
          {
            name: '充电量',
            type: 'bar',
            yAxisIndex: 1,
            data: elecValues,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFD700' },
                { offset: 1, color: '#FFA500' }
              ]),
              borderRadius: [2, 2, 0, 0]
            },
            barWidth: '30%'
          }
        ]
      };
    },
    deviceStatusChartOption() {
      if (!this.deviceStatusData || !this.deviceStatusData.totalCount) {
        return {};
      }
      
      const categories = ['使用中', '空闲', '离线', '故障'];
      const statusDataMap = {
        '使用中': this.deviceStatusData.chargeData,
        '空闲': this.deviceStatusData.idleData,
        '离线': this.deviceStatusData.offlineData,
        '故障': this.deviceStatusData.faultData
      };
      
      const colorMap = {
        '使用中': new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#0066ff' },
          { offset: 1, color: '#00aaff' }
        ]),
        '空闲': new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#00d4ff' },
          { offset: 1, color: '#00aaff' }
        ]),
        '离线': new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#8c8c8c' },
          { offset: 1, color: '#595959' }
        ]),
        '故障': new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#ff4d4f' },
          { offset: 1, color: '#ff7875' }
        ])
      };
      
      // 计算总数量
      const totalFast = categories.reduce((sum, cat) => sum + (statusDataMap[cat].fastCount || 0), 0);
      const totalSlow = categories.reduce((sum, cat) => sum + (statusDataMap[cat].slowCount || 0), 0);
      
      // 构建双环形图数据
      const innerData = categories.map(cat => ({
        name: cat,
        value: statusDataMap[cat].fastCount || 0,
        itemStyle: {
          color: colorMap[cat]
        }
      }));
      
      const outerData = categories.map(cat => ({
        name: cat,
        value: statusDataMap[cat].slowCount || 0,
        itemStyle: {
          color: colorMap[cat]
        }
      }));
      
      return {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 20, 40, 0.9)',
          borderColor: '#00d4ff',
          textStyle: {
            color: '#fff'
          },
          formatter: (params) => {
            const category = params.name;
            const statusData = statusDataMap[category];
            const chargeType = params.seriesName === '快充' ? '快充' : '慢充';
            const total = chargeType === '快充' ? totalFast : totalSlow;
            const percentage = total > 0 ? ((params.value / total) * 100).toFixed(2) : 0;
            return `<div style="font-weight:bold;margin-bottom:5px;">${category}（${chargeType}）</div>
                    <div>台数：${params.value}台</div>
                    <div>占比：${percentage}%</div>`;
          }
        },
        legend: {
          show: false
        },
        series: [
          {
            name: '快充',
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#0a1628',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: false
              }
            },
            data: innerData
          },
          {
            name: '慢充',
            type: 'pie',
            radius: ['60%', '75%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#0a1628',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: false
              }
            },
            data: outerData
          }
        ]
      };
    }
  },
  beforeUnmount() {
    this._isMounted = false;
    this.stopAutoScroll();
    this.stopChargeAmountAnimation();
    if (this.timeTimer) {
      clearInterval(this.timeTimer);
      this.timeTimer = null;
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  methods: {
    // 获取实时天气数据（使用 Open-Meteo API，根据选择的区域动态获取对应城市天气）
    async fetchWeather() {
      try {
        // 根据当前选择的区域代码获取对应的城市经纬度
        const weatherConfig = this.provinceWeatherMap[this.region] || this.provinceWeatherMap[''];
        const { name, latitude, longitude } = weatherConfig;
        
        // 更新当前显示的城市名称
        this.currentWeatherCity = name;
        
        const response = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m&timezone=Asia/Shanghai`
        );
        
        if (!response.ok) {
          throw new Error('获取天气数据失败');
        }
        
        const data = await response.json();
        const current = data.current;
        
        // 天气代码描述映射（WMO Weather interpretation codes）
        const weatherDescriptions = {
          0: '晴',
          1: '大部晴朗',
          2: '多云',
          3: '阴天',
          45: '雾',
          48: '雾凇',
          51: '小毛毛雨',
          53: '中毛毛雨',
          55: '大毛毛雨',
          56: '冻毛毛雨',
          57: '重冻毛毛雨',
          61: '小雨',
          63: '中雨',
          65: '大雨',
          66: '小冻雨',
          67: '大冻雨',
          71: '小雪',
          73: '中雪',
          75: '大雪',
          77: '雪粒',
          80: '小阵雨',
          81: '中阵雨',
          82: '大阵雨',
          85: '小阵雪',
          86: '大阵雪',
          95: '雷暴',
          96: '雷暴伴小冰雹',
          99: '雷暴大冰雹'
        };
        
        this.weatherData = {
          temperature: Math.round(current.temperature_2m),
          description: weatherDescriptions[current.weather_code] || '未知',
          humidity: current.relative_humidity_2m,
          windSpeed: current.wind_speed_10m
        };
      } catch (error) {
        console.error('获取天气数据失败:', error);
        this.weatherData.description = '获取失败';
      }
    },
    // 检测全屏状态（F11全屏）
    checkFullscreen() {
      // F11全屏时，window.innerHeight 接近 screen.height
      const isFullscreen = window.innerHeight >= screen.height - 10;
      if (isFullscreen) {
        document.body.classList.add('is-fullscreen');
      } else {
        document.body.classList.remove('is-fullscreen');
      }
    },
    // 启动定时刷新
    startRefreshTimer() {
      // 先清除已有定时器，确保只有一个定时刷新任务
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
      const interval = parseInt(this.refreshTime) * 1000;
      this.refreshTimer = setInterval(() => {
        this.refreshAllData();
      }, interval);
    },
    // 手动刷新
    manualRefresh() {
      this.refreshAllData();
    },
    // 刷新时间间隔变化
    onRefreshTimeChange() {
      this.startRefreshTimer();
    },
    // 刷新所有数据
    refreshAllData() {
      this.fetchTodayMetrics();
      this.fetchScaleData();
      this.fetchStationRanking();
      this.fetchRealtimeOrders();
      this.fetchPeakValleyData();
      this.fetchUtilizationRate();
      this.fetchRealTimeStatus();
      this.fetchRealtimeAlarms();
      this.fetchWeather(); // 刷新天气数据
      this.fetchMapData(this.provinceCode);
    },
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      this.currentDate = `${year}-${month}-${day}`;
      this.currentTime = `${hours}:${minutes}:${seconds}`;
      
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.currentWeekday = weekdays[now.getDay()];
    },
    fetchTodayMetrics() {
      // 获取今日数据统计
      let that = this;
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : ''
      };
      that.$axios.post("bi-server/dashboard/todayMetrics", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data) {
          // 更新充电量（保留4位小数）
          const totalElec = parseFloat(result.data.totalElec || 0).toFixed(4);
          that.updateTodayStatsItem('chargeAmount', totalElec);
          // 更新单枪充电量（保留4位小数）
          const avgConnectorElec = parseFloat(result.data.avgConnectorElec || 0).toFixed(4);
          that.updateTodayStatsItem('singleGunCharge', avgConnectorElec);
          // 更新今日营收
          that.updateTodayStatsItem('todayRevenue', result.data.totalAmt || '0');
          // 更新充电车次
          that.updateTodayStatsItem('chargeTimes', result.data.chargeCount || '0');
          // 更新数据更新时间
          const now = new Date();
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          that.dataUpdateTime = `${hours}:${minutes}:${seconds}`;
        }
      }).catch(err => {
        console.error('获取今日数据失败:', err);
      });
    },
    fetchStationRanking() {
      // 获取场站排行榜数据
      let that = this;
      const dateParams = this.getDateRangeParams();
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : '',
        startTime: dateParams.startTime,
        endTime: dateParams.endTime
      };
      that.$axios.post("bi-server/dashboard/stationRanking", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data && result.data.length > 0) {
          // 直接存储接口返回的原始数据
          that.stationRanking = result.data;
        } else {
          that.stationRanking = [];
        }
      }).catch(err => {
        console.error('获取场站排行榜数据失败:', err);
      });
    },
    fetchRealtimeOrders() {
      // 获取实时订单数据
      let that = this;
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : ''
      };
      that.$axios.post("bi-server/dashboard/realtimeOrder", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data && result.data.length > 0) {
          // 转换接口数据格式
          that.realTimeOrders = result.data.map(item => ({
            time: item.chargeStartTime || '',
            phone: item.phoneNumber || '',
            station: item.name || '',
            type: item.connectorType === 1 ? '交流' : '直流',
            amount: item.elec ? item.elec.toFixed(2) : '0.00'
          }));
          // 更新进行中订单数
          that.orderCount = result.data.length;
        } else {
          that.realTimeOrders = [];
          that.orderCount = 0;
        }
      }).catch(err => {
        console.error('获取实时订单数据失败:', err);
      });
    },
    fetchUtilizationRate() {
      // 获取设备利用率数据
      let that = this;
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : ''
      };
      that.$axios.post("bi-server/dashboard/utilizationRate", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data) {
          that.utilizationData = {
            fastTimeUtilizationRate: result.data.fastTimeUtilRate || 0,
            fastPowerUtilizationRate: result.data.FastPowerUtilRate || 0,
            slowTimeUtilizationRate: result.data.slowTimeUtilRate || 0,
            slowPowerUtilizationRate: result.data.slowPowerUtilRate || 0
          };
        }
      }).catch(err => {
        console.error('获取设备利用率数据失败:', err);
      });
    },
    fetchPeakValleyData() {
      // 获取尖峰平谷充电量数据
      let that = this;
      const dateParams = this.getDateRangeParams();
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : '',
        startTime: dateParams.startTime,
        endTime: dateParams.endTime
      };
      that.$axios.post("bi-server/dashboard/timePeriodRatio", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data) {
          that.peakValleyData = {
            peakRate: result.data.peakRate || 0,
            highRate: result.data.highRate || 0,
            flatRate: result.data.flatRate || 0,
            valleyRate: result.data.valleyRate || 0,
            chargingHourDatas: result.data.chargingHourDatas || []
          };
          // 数据更新后重新渲染图表
          that.$nextTick(() => {
            that.initPeakValleyChart();
          });
        }
      }).catch(err => {
        console.error('获取尖峰平谷数据失败:', err);
      });
    },
    fetchRealTimeStatus() {
      // 获取设备实时状态数据
      let that = this;
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : ''
      };
      that.$axios.post("bi-server/dashboard/realTimeStatus", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data) {
          that.deviceStatusData = {
            totalCount: result.data.totalCount || 0,
            idleData: result.data.idleData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            chargeData: result.data.chargeData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            offlineData: result.data.offlineData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            faultData: result.data.faultData || { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 }
          };
        } else {
          that.deviceStatusData = {
            totalCount: 0,
            idleData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            chargeData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            offlineData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 },
            faultData: { fastCount: 0, slowCount: 0, fastRate: 0, slowRate: 0 }
          };
        }
      }).catch(err => {
        console.error('获取设备实时状态数据失败:', err);
      });
    },
    fetchRealtimeAlarms() {
      // 获取实时告警数据
      let that = this;
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : ''
      };
      that.$axios.post("bi-server/dashboard/realtimeAlarms", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data && result.data.length > 0) {
          // 转换接口数据格式
          that.alarmList = result.data.map(item => ({
            time: item.reportTime || '',
            device: item.alarmDeviceName || '',
            name: item.alarmDesc || '',
            status: item.alarmStaus || '未处理'
          }));
          // 统计未处理告警数量
          that.alarmCount = that.alarmList.filter(item => item.status === '未处理').length;
        } else {
          that.alarmList = [];
          that.alarmCount = 0;
        }
      }).catch(err => {
        console.error('获取实时告警数据失败:', err);
      });
    },
    // 更新今日数据项（带增长动效）
    updateTodayStatsItem(fieldKey, newValue) {
      const oldValue = parseFloat(this.todayStats[fieldKey].value) || 0;
      const numValue = parseFloat(newValue) || 0;
      const diff = numValue - oldValue;
      
      // 只有数据增加时才触发动效
      if (diff > 0) {
        this.todayStats[fieldKey] = {
          value: newValue,
          diff: diff,
          isIncreasing: true
        };
        
        // 1.5秒后关闭动效
        setTimeout(() => {
          this.todayStats[fieldKey].isIncreasing = false;
        }, 1500);
      } else {
        // 数据减少或不变，直接更新
        this.todayStats[fieldKey] = {
          value: newValue,
          diff: 0,
          isIncreasing: false
        };
      }
    },
    fetchScaleData() {
      // 获取规模数据统计
      let that = this;
      const dateParams = that.getDateRangeParams();
      let param = {
        provinceCode: that.provinceCode || '',
        stationType: that.stationType !== 'all' ? that.stationType : '',
        startTime: dateParams.startTime,
        endTime: dateParams.endTime
      };
      that.$axios.post("bi-server/dashboard/scaleStatistics", JSON.stringify(param)).then(result => {
        if(result.code == 200 && result.data) {
          // 更新规模数据 - 地图顶部悬浮数据
          that.updateScaleDataItem('scaleData', 'totalRevenue', result.data.totalAmt || '0');
          that.updateScaleDataItem('scaleData', 'singleGunCharge', result.data.avgConnectorElec || '0');
          that.updateScaleDataItem('scaleData', 'totalTimes', result.data.totalChargeCount || '0');
          // 更新地图底部悬浮数据 - 运营数据
          that.updateScaleDataItem('mapStats', 'stationCount', result.data.stationCount || '0');
          that.updateScaleDataItem('mapStats', 'fastGunCount', result.data.totalFastCount || '0');
          that.updateScaleDataItem('mapStats', 'slowGunCount', result.data.totalSlowCount || '0');
          that.updateScaleDataItem('mapStats', 'userCount', result.data.registerUserCount || '0');
          // 更新地图底部悬浮数据 - 在建数据
          that.updateScaleDataItem('mapStats', 'buildStationCount', result.data.buildStationCount || '0');
          that.updateScaleDataItem('mapStats', 'buildFastGunCount', result.data.buildFastCount || '0');
          that.updateScaleDataItem('mapStats', 'buildSlowGunCount', result.data.buildSlowCount || '0');
          // 更新翻牌显示的总充电量
          that.updateChargeAmountDisplay(result.data.totalElec || '0');
        } else {
          // 接口返回data为null或没有数据时，归零处理
          that.scaleData = {
            totalRevenue: { value: '0', diff: 0, isIncreasing: false },
            singleGunCharge: { value: '0', diff: 0, isIncreasing: false },
            totalTimes: { value: '0', diff: 0, isIncreasing: false }
          };
          that.mapStats = {
            stationCount: { value: '0', diff: 0, isIncreasing: false },
            fastGunCount: { value: '0', diff: 0, isIncreasing: false },
            slowGunCount: { value: '0', diff: 0, isIncreasing: false },
            userCount: { value: '0', diff: 0, isIncreasing: false },
            buildStationCount: { value: '0', diff: 0, isIncreasing: false },
            buildFastGunCount: { value: '0', diff: 0, isIncreasing: false },
            buildSlowGunCount: { value: '0', diff: 0, isIncreasing: false }
          };
          that.updateChargeAmountDisplay('0');
        }
      }).catch(err => {
        console.error('获取规模数据失败:', err);
      });
    },
    // 更新规模数据项（带增长动效）
    updateScaleDataItem(dataKey, fieldKey, newValue) {
      const dataObj = this[dataKey];
      const oldValue = parseFloat(dataObj[fieldKey].value) || 0;
      const numValue = parseFloat(newValue) || 0;
      const diff = numValue - oldValue;
      
      // 只有数据增加时才触发动效
      if (diff > 0) {
        dataObj[fieldKey] = {
          value: newValue,
          diff: diff,
          isIncreasing: true
        };
        
        // 1.5秒后关闭动效
        setTimeout(() => {
          dataObj[fieldKey].isIncreasing = false;
        }, 1500);
      } else {
        // 数据减少或不变，直接更新
        dataObj[fieldKey] = {
          value: newValue,
          diff: 0,
          isIncreasing: false
        };
      }
    },
    // 格式化增量显示（2位小数，用于充电量、营收等）
    formatDiff(diff) {
      const numDiff = parseFloat(diff) || 0;
      if (numDiff >= 10000) {
        return (numDiff / 10000).toFixed(2) + 'W';
      } else if (numDiff >= 1000) {
        return (numDiff / 1000).toFixed(2) + 'K';
      }
      return numDiff.toFixed(2);
    },
    // 格式化增量显示（4位小数，用于单枪充电量）
    formatDiff4(diff) {
      const numDiff = parseFloat(diff) || 0;
      if (numDiff >= 10000) {
        return (numDiff / 10000).toFixed(4) + 'W';
      } else if (numDiff >= 1000) {
        return (numDiff / 1000).toFixed(4) + 'K';
      }
      return numDiff.toFixed(4);
    },
    // 格式化增量显示（整数，用于车次、场站数等）
    formatDiffInteger(diff) {
      const numDiff = parseFloat(diff) || 0;
      if (numDiff >= 10000) {
        return (numDiff / 10000).toFixed(2) + 'W';
      } else if (numDiff >= 1000) {
        return (numDiff / 1000).toFixed(2) + 'K';
      }
      return Math.floor(numDiff).toString();
    },
    // 格式化单枪充电量显示，保留4位小数，大于等于一百万添加W单位，小于100万添加千分位
    formatSingleGunCharge(value) {
      const numValue = parseFloat(value) || 0;
      if (numValue >= 1000000) {
        return (numValue / 10000).toFixed(4) + '万';
      }
      const parts = numValue.toFixed(4).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    // 格式化数值显示，大于等于一百万添加万单位，小于100万添加千分位
    formatWithWUnit(value) {
      const numValue = parseFloat(value) || 0;
      if (numValue >= 1000000) {
        return (numValue / 10000).toFixed(2) + '万';
      }
      const parts = numValue.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    // 格式化金额显示，保留2位小数，大于等于一百万添加万单位，小于100万添加千分位
    formatRevenue(value) {
      const numValue = parseFloat(value) || 0;
      if (numValue >= 1000000) {
        return (numValue / 10000).toFixed(2) + '万';
      }
      const parts = numValue.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    // 格式化整数显示，0位小数，大于等于一百万添加万单位，小于100万添加千分位
    formatInteger(value) {
      const numValue = parseFloat(value) || 0;
      if (numValue >= 1000000) {
        return (numValue / 10000).toFixed(2) + '万';
      }
      return Math.floor(numValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    handleViewTypeChange() {
      this.setViewDateDefault();
    },
    setViewDateDefault() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const today = `${year}-${month}-${day}`;
      
      if (this.viewType === 'day') {
        this.viewDateRange = [today, today];
      } else if (this.viewType === 'month') {
        this.viewDateRange = [`${year}-${month}`, `${year}-${month}`];
      } else if (this.viewType === 'quarter') {
        const q = Math.floor(now.getMonth() / 3) + 1;
        this.viewDateRange = [`${year}-Q${q}`, `${year}-Q${q}`];
      } else if (this.viewType === 'year') {
        this.viewDateRange = [`${year}`, `${year}`];
      } else {
        this.viewDateRange = [];
      }
    },
    getDateRangeParams() {
      if (!this.viewDateRange || this.viewDateRange.length !== 2) {
        return { startTime: '', endTime: '' };
      }
      
      const [start, end] = this.viewDateRange;
      let startTime = '';
      let endTime = '';
      
      if (this.viewType === 'day') {
        startTime = start;
        endTime = end;
      } else if (this.viewType === 'month') {
        startTime = `${start}-01`;
        const endYear = end.split('-')[0];
        const endMonth = end.split('-')[1];
        const lastDay = new Date(endYear, endMonth, 0).getDate();
        endTime = `${endYear}-${endMonth}-${String(lastDay).padStart(2, '0')}`;
      } else if (this.viewType === 'quarter') {
        const startMatch = start.match(/(\d{4})-Q(\d)/);
        const endMatch = end.match(/(\d{4})-Q(\d)/);
        if (startMatch && endMatch) {
          const startQuarter = parseInt(startMatch[2]);
          const endQuarter = parseInt(endMatch[2]);
          const startMonth = String((startQuarter - 1) * 3 + 1).padStart(2, '0');
          const endMonth = String(endQuarter * 3).padStart(2, '0');
          startTime = `${startMatch[1]}-${startMonth}-01`;
          const lastDay = new Date(endMatch[1], endQuarter * 3, 0).getDate();
          endTime = `${endMatch[1]}-${endMonth}-${String(lastDay).padStart(2, '0')}`;
        }
      } else if (this.viewType === 'year') {
        startTime = `${start}-01-01`;
        endTime = `${end}-12-31`;
      }
      
      return { startTime, endTime };
    },
    initCharts() {
      this.initMap();
      this.initPeakValleyChart();
    },
    // 绑定地图事件（监听用户缩放和拖拽）
    bindMapEvents() {
      this.$nextTick(() => {
        const chartRef = this.$refs.mapChart;
        if (chartRef) {
          // vue-echarts 的实例获取方式
          this.mapChartInstance = chartRef.chart || chartRef.getInstance();
          if (this.mapChartInstance) {
            // 监听 georoam 事件，实时保存用户的缩放和位移状态
            this.mapChartInstance.on('georoam', (params) => {
              // 只有在非首次加载时才保存用户状态
              if (!this.mapFirstLoad) {
                const option = this.mapChartInstance.getOption();
                if (option && option.geo && option.geo[0]) {
                  const geo = option.geo[0];
                  if (geo.zoom !== undefined) {
                    this.mapUserState.zoom = geo.zoom;
                  }
                  if (geo.center) {
                    this.mapUserState.center = [...geo.center];
                  }
                }
              }
            });
          }
        }
      });
    },
    // 初始化地图
    initMap() {
      // 根据账号所属区域加载对应的地图
      const provinceCode = localStorage.getItem('provinceCode') || '';
      const province = localStorage.getItem('province') || '';
      
      // 中文省份名到英文文件名的映射
      const provinceNameMap = {
        '广东省': 'guangdong',
        '福建省': 'fujian',
        '安徽省': 'anhui',
        '广西省': 'guangxi',
        '浙江省': 'zhejiang',
        '江苏省': 'jiangsu',
        '北京': 'beijing',
        '上海': 'shanghai'
      };
      
      if (provinceCode && provinceNameMap[province]) {
        const englishName = provinceNameMap[province];
        const provinceUrl = `https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/province/${englishName}.json`;
        this.currentProvince = province;
        this.currentProvinceCode = provinceCode;
        this.mapLevel = 'province';
        // 先加载地图，地图加载完成后再获取数据
        this.loadProvinceMap(province, provinceUrl, () => {
          this.fetchMapData(provinceCode);
        });
      } else {
        // 没有省份信息时加载全国地图
        this.currentProvince = '';
        this.currentProvinceCode = '';
        this.mapLevel = 'china';
        // 先加载地图，地图加载完成后再获取数据
        this.loadMapData('china', 'https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/china.json', () => {
          this.fetchMapData('');
        });
      }
    },
    // 获取地图电量数据
    fetchMapData(provinceCode) {
      // 生成新的请求ID
      const requestId = ++this.mapDataRequestId;
      
      const dateParams = this.getDateRangeParams();
      const param = {
        provinceCode: provinceCode || '',
        stationType: this.stationType !== 'all' ? this.stationType : '',
        startTime: dateParams.startTime,
        endTime: dateParams.endTime
      };
      
      this.$axios.post("bi-server/dashboard/mapData", JSON.stringify(param)).then(result => {
        // 检查是否是最新的请求
        if (requestId !== this.mapDataRequestId) {
          return; // 忽略过期请求的结果
        }
        
        if (result.code == 200 && result.data) {
          this.mapElecData = {};
          this.processMapElecData(result.data);
          
          // 更新地图显示 - 只更新数据部分，不触碰 geo 配置
          if (this.mapChartInstance) {
            const mapName = this.currentMapRegion;
            const _mapElecData = this.mapElecData;
            
            // 根据当前地图类型决定省份数据
            let provinces = [];
            if (mapName === 'china') {
              provinces = [
                { name: '新疆', value: (this.mapElecData['新疆'] && this.mapElecData['新疆'].gunCount) || 0 },
                { name: '西藏', value: (this.mapElecData['西藏'] && this.mapElecData['西藏'].gunCount) || 0 },
                { name: '青海', value: (this.mapElecData['青海'] && this.mapElecData['青海'].gunCount) || 0 },
                { name: '甘肃', value: (this.mapElecData['甘肃'] && this.mapElecData['甘肃'].gunCount) || 0 },
                { name: '内蒙古', value: (this.mapElecData['内蒙古'] && this.mapElecData['内蒙古'].gunCount) || 0 },
                { name: '宁夏', value: (this.mapElecData['宁夏'] && this.mapElecData['宁夏'].gunCount) || 0 },
                { name: '黑龙江', value: (this.mapElecData['黑龙江'] && this.mapElecData['黑龙江'].gunCount) || 0 },
                { name: '吉林', value: (this.mapElecData['吉林'] && this.mapElecData['吉林'].gunCount) || 0 },
                { name: '辽宁', value: (this.mapElecData['辽宁'] && this.mapElecData['辽宁'].gunCount) || 0 },
                { name: '河北', value: (this.mapElecData['河北'] && this.mapElecData['河北'].gunCount) || 0 },
                { name: '北京', value: (this.mapElecData['北京'] && this.mapElecData['北京'].gunCount) || 0 },
                { name: '天津', value: (this.mapElecData['天津'] && this.mapElecData['天津'].gunCount) || 0 },
                { name: '山西', value: (this.mapElecData['山西'] && this.mapElecData['山西'].gunCount) || 0 },
                { name: '陕西', value: (this.mapElecData['陕西'] && this.mapElecData['陕西'].gunCount) || 0 },
                { name: '山东', value: (this.mapElecData['山东'] && this.mapElecData['山东'].gunCount) || 0 },
                { name: '河南', value: (this.mapElecData['河南'] && this.mapElecData['河南'].gunCount) || 0 },
                { name: '江苏', value: (this.mapElecData['江苏'] && this.mapElecData['江苏'].gunCount) || 0 },
                { name: '安徽', value: (this.mapElecData['安徽'] && this.mapElecData['安徽'].gunCount) || 0 },
                { name: '浙江', value: (this.mapElecData['浙江'] && this.mapElecData['浙江'].gunCount) || 0 },
                { name: '上海', value: (this.mapElecData['上海'] && this.mapElecData['上海'].gunCount) || 0 },
                { name: '湖北', value: (this.mapElecData['湖北'] && this.mapElecData['湖北'].gunCount) || 0 },
                { name: '湖南', value: (this.mapElecData['湖南'] && this.mapElecData['湖南'].gunCount) || 0 },
                { name: '江西', value: (this.mapElecData['江西'] && this.mapElecData['江西'].gunCount) || 0 },
                { name: '福建', value: (this.mapElecData['福建'] && this.mapElecData['福建'].gunCount) || 0 },
                { name: '广东', value: (this.mapElecData['广东'] && this.mapElecData['广东'].gunCount) || 0 },
                { name: '广西', value: (this.mapElecData['广西'] && this.mapElecData['广西'].gunCount) || 0 },
                { name: '海南', value: (this.mapElecData['海南'] && this.mapElecData['海南'].gunCount) || 0 },
                { name: '四川', value: (this.mapElecData['四川'] && this.mapElecData['四川'].gunCount) || 0 },
                { name: '重庆', value: (this.mapElecData['重庆'] && this.mapElecData['重庆'].gunCount) || 0 },
                { name: '贵州', value: (this.mapElecData['贵州'] && this.mapElecData['贵州'].gunCount) || 0 },
                { name: '云南', value: (this.mapElecData['云南'] && this.mapElecData['云南'].gunCount) || 0 },
                { name: '台湾', value: 0 }
              ];
            } else if (this.mapLevel === 'city') {
              // 城市地图：从地图features中提取区县名称，匹配mapElecData中的数据
              
              // 上海各区标签偏移配置 [x, y]
              const shanghaiLabelOffset = {
                '杨浦区': [0, -25],
                '浦东新区': [0, 35],
                '虹口区': [0, -10],
                '静安区': [0, 10],
                '长宁区': [0, 15],
                '黄浦区': [0, 15],
                '普陀区': [0, -10]
              };
              
              const mapJson = echarts.getMap(mapName);
              if (mapJson && mapJson.geoJson && mapJson.geoJson.features) {
                mapJson.geoJson.features.forEach(feature => {
                  const name = feature.properties.name;
                  const data = this.mapElecData[name] || {};
                  
                  const provinceData = {
                    name: name,
                    value: data.gunCount || 0
                  };
                  
                  // 为特定区域添加标签偏移配置
                  if (shanghaiLabelOffset[name]) {
                    provinceData.label = {
                      offset: shanghaiLabelOffset[name]
                    };
                  }
                  
                  provinces.push(provinceData);
                });
              }
              
            } else {
              // 省份地图使用 codeToNameMap 获取区域名称
              
              provinces = Object.keys(this.codeToNameMap).map(code => {
                const name = this.codeToNameMap[code];
                const data = this.mapElecData[name];
                return {
                  name: name,
                  value: (data && data.gunCount) || 0
                };
              });
              
            }
            
            // 计算最大值
            const values = provinces.map(p => p.value);
            const maxVal = Math.max(...values, 1);
            
            // 构建涟漪散点数据
            const scatterData = [];
            provinces.forEach(province => {
              if (province.value > 0) {
                const center = this.getRegionCenter(province.name);
                if (center) {
                  const regionData = _mapElecData[province.name] || {};
                  scatterData.push({
                    name: province.name,
                    value: [center[0], center[1], regionData.stationCount || 0],
                    stationCount: regionData.stationCount || 0
                  });
                }
              }
            });
            
            // 刷新数据时只更新 series 和 visualMap，不触碰 geo 配置
            // 注意：必须保留 series 的完整配置（如 geoIndex、coordinateSystem 等），否则地图数据会显示为 0 或变白色
            // 使用 notMerge: false（默认）来合并配置，保留原有的 geo 样式
            // 使用 lazyUpdate: true 避免立即重新渲染导致涟漪散点跳变
            // visualMap 使用 seriesIndex: 0 关联到地图系列，根据数据值控制颜色
            // geo 的 itemStyle.areaColor 作为无数据区域的默认颜色
            this.mapChartInstance.setOption({
              series: [
                { 
                  name: '充电量',
                  type: 'map',
                  map: mapName,
                  data: provinces,
                  itemStyle: {
                    borderColor: '#1a3a6a',
                    borderWidth: 1
                  },
                  emphasis: {
                    label: { show: true, color: '#fff' },
                    itemStyle: {
                      areaColor: '#4a8ae0'
                    }
                  },
                  select: {
                    itemStyle: {
                      areaColor: '#4a8ae0'
                    }
                  },
                  tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    borderColor: '#1890ff',
                    textStyle: { color: '#fff' },
                    formatter: function(params) {
                      const regionData = _mapElecData[params.name] || {};
                      const gunCount = regionData.gunCount || 0;
                      const stationCount = regionData.stationCount || 0;
                      const chargeAmount = regionData.chargeAmount || 0;
                      
                      let tip = '<div style="font-weight:bold;margin-bottom:5px;">' + params.name + '</div>';
                      tip += '<div>充电站数：<span style="color:#67C23A;">' + stationCount + '</span> 个</div>';
                      tip += '<div>充电枪数：<span style="color:#409EFF;">' + gunCount + '</span> 个</div>';
                      tip += '<div>充电量：<span style="color:#E6A23C;">' + chargeAmount + '</span> kWh</div>';
                      return tip;
                    }
                  }
                },
                { 
                  name: '充电站数',
                  type: 'effectScatter',
                  coordinateSystem: 'geo',
                  symbolSize: function(val) {
                    const count = val[2];
                    return Math.min(Math.max(20, Math.sqrt(count) * 3), 50);
                  },
                  showEffectOn: 'render',
                  rippleEffect: {
                    brushType: 'stroke',
                    scale: 3,
                    period: 4
                  },
                  label: {
                    show: true,
                    formatter: function(param) {
                      return param.data.stationCount || 0;
                    },
                    position: 'inside',
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 'bold'
                  },
                  itemStyle: {
                    color: '#00d4ff',
                    borderColor: '#1FDAFF',
                    borderWidth: 2,
                    shadowBlur: 10,
                    shadowColor: '#333'
                  },
                  zlevel: 1,
                  data: scatterData 
                }
              ],
              visualMap: {
                min: 0,
                max: maxVal,
                seriesIndex: 0,
                left: 'left',
                top: 'bottom',
                text: ['高', '低'],
                textStyle: { color: '#fff' },
                inRange: {
                  color: ['#1067B3', '#0C86CC', '#07AAE6', '#56CAF5', '#96E3FF']
                },
                outOfRange: {
                  color: '#1a5fb4'
                },
                show: false
              }
            }, false, { lazyUpdate: true });
          }
        }
      }).catch(err => {
        console.error('获取地图数据失败:', err);
      });
    },
    // 处理地图电量数据
    processMapElecData(data) {
      if (!data) {
        return;
      }
      

      

      
      // 创建新对象以确保响应式更新 - 使用名称作为key
      const newData = {};
      
      // 代码到名称的映射表（省份级别）
      const provinceCodeMap = {
        '110000': '北京',
        '120000': '天津',
        '310000': '上海',
        '500000': '重庆',
        '130000': '河北',
        '140000': '山西',
        '210000': '辽宁',
        '220000': '吉林',
        '230000': '黑龙江',
        '320000': '江苏',
        '330000': '浙江',
        '340000': '安徽',
        '350000': '福建',
        '360000': '江西',
        '370000': '山东',
        '410000': '河南',
        '420000': '湖北',
        '430000': '湖南',
        '440000': '广东',
        '450000': '广西',
        '460000': '海南',
        '510000': '四川',
        '520000': '贵州',
        '530000': '云南',
        '540000': '西藏',
        '610000': '陕西',
        '620000': '甘肃',
        '630000': '青海',
        '640000': '宁夏',
        '650000': '新疆',
        '710000': '台湾',
        '150000': '内蒙古',
        '810000': '香港',
        '820000': '澳门'
      };
      
      // 区级代码到名称的映射表（用于省份地图下钻到区级）
      const districtCodeMap = {
        // 北京各区
        '110101': '东城区', '110102': '西城区', '110105': '朝阳区', '110106': '丰台区',
        '110107': '石景山区', '110108': '海淀区', '110109': '门头沟区', '110111': '房山区',
        '110112': '通州区', '110113': '顺义区', '110114': '昌平区', '110115': '大兴区',
        '110116': '怀柔区', '110117': '平谷区', '110118': '密云区', '110119': '延庆区',
        // 上海各区
        '310101': '黄浦区', '310104': '徐汇区', '310105': '长宁区', '310106': '静安区',
        '310107': '普陀区', '310109': '虹口区', '310110': '杨浦区', '310112': '闵行区',
        '310113': '宝山区', '310114': '嘉定区', '310115': '浦东新区', '310116': '金山区',
        '310117': '松江区', '310118': '青浦区', '310120': '奉贤区', '310151': '崇明区',
        // 广东各区（广州市）
        '440103': '荔湾区', '440104': '越秀区', '440105': '海珠区', '440106': '天河区',
        '440111': '白云区', '440112': '黄埔区', '440113': '番禺区', '440114': '花都区',
        '440115': '南沙区', '440117': '从化区', '440118': '增城区',
        // 深圳各区
        '440303': '罗湖区', '440304': '福田区', '440305': '南山区', '440306': '宝安区',
        '440307': '龙岗区', '440308': '盐田区', '440309': '龙华区', '440310': '坪山区',
        '440311': '光明区'
      };
      
      // 城市代码到名称的映射表
      const cityCodeMap = {
        // 北京
        '110100': '北京市',
        // 天津
        '120100': '天津市',
        // 上海
        '310100': '上海市',
        // 重庆
        '500100': '重庆市',
        // 河北
        '130100': '石家庄市', '130200': '唐山市', '130300': '秦皇岛市', '130400': '邯郸市',
        '130500': '邢台市', '130600': '保定市', '130700': '张家口市', '130800': '承德市',
        '130900': '沧州市', '131000': '廊坊市', '131100': '衡水市',
        // 山西
        '140100': '太原市', '140200': '大同市', '140300': '阳泉市', '140400': '长治市',
        '140500': '晋城市', '140600': '朔州市', '140700': '晋中市', '140800': '运城市',
        '140900': '忻州市', '141000': '临汾市', '141100': '吕梁市',
        // 辽宁
        '210100': '沈阳市', '210200': '大连市', '210300': '鞍山市', '210400': '抚顺市',
        '210500': '本溪市', '210600': '丹东市', '210700': '锦州市', '210800': '营口市',
        '210900': '阜新市', '211000': '辽阳市', '211100': '盘锦市', '211200': '铁岭市',
        '211300': '朝阳市', '211400': '葫芦岛市',
        // 吉林
        '220100': '长春市', '220200': '吉林市', '220300': '四平市', '220400': '辽源市',
        '220500': '通化市', '220600': '白山市', '220700': '松原市', '220800': '白城市',
        '222400': '延边朝鲜族自治州',
        // 黑龙江
        '230100': '哈尔滨市', '230200': '齐齐哈尔市', '230300': '鸡西市', '230400': '鹤岗市',
        '230500': '双鸭山市', '230600': '大庆市', '230700': '伊春市', '230800': '佳木斯市',
        '230900': '七台河市', '231000': '牡丹江市', '231100': '黑河市', '231200': '绥化市',
        '232700': '大兴安岭地区',
        // 江苏
        '320100': '南京市', '320200': '无锡市', '320300': '徐州市', '320400': '常州市',
        '320500': '苏州市', '320600': '南通市', '320700': '连云港市', '320800': '淮安市',
        '320900': '盐城市', '321000': '扬州市', '321100': '镇江市', '321200': '泰州市',
        '321300': '宿迁市',
        // 浙江
        '330100': '杭州市', '330200': '宁波市', '330300': '温州市', '330400': '嘉兴市',
        '330500': '湖州市', '330600': '绍兴市', '330700': '金华市', '330800': '衢州市',
        '330900': '舟山市', '331000': '台州市', '331100': '丽水市',
        // 安徽
        '340100': '合肥市', '340200': '芜湖市', '340300': '蚌埠市', '340400': '淮南市',
        '340500': '马鞍山市', '340600': '淮北市', '340700': '铜陵市', '340800': '安庆市',
        '341000': '黄山市', '341100': '滁州市', '341200': '阜阳市', '341300': '宿州市',
        '341500': '六安市', '341600': '亳州市', '341700': '池州市', '341800': '宣城市',
        // 福建
        '350100': '福州市', '350200': '厦门市', '350300': '莆田市', '350400': '三明市',
        '350500': '泉州市', '350600': '漳州市', '350700': '南平市', '350800': '龙岩市',
        '350900': '宁德市',
        // 江西
        '360100': '南昌市', '360200': '景德镇市', '360300': '萍乡市', '360400': '九江市',
        '360500': '新余市', '360600': '鹰潭市', '360700': '赣州市', '360800': '吉安市',
        '360900': '宜春市', '361000': '抚州市', '361100': '上饶市',
        // 山东
        '370100': '济南市', '370200': '青岛市', '370300': '淄博市', '370400': '枣庄市',
        '370500': '东营市', '370600': '烟台市', '370700': '潍坊市', '370800': '济宁市',
        '370900': '泰安市', '371000': '威海市', '371100': '日照市', '371300': '临沂市',
        '371400': '德州市', '371500': '聊城市', '371600': '滨州市', '371700': '菏泽市',
        // 河南
        '410100': '郑州市', '410200': '开封市', '410300': '洛阳市', '410400': '平顶山市',
        '410500': '安阳市', '410600': '鹤壁市', '410700': '新乡市', '410800': '焦作市',
        '410900': '濮阳市', '411000': '许昌市', '411100': '漯河市', '411200': '三门峡市',
        '411300': '南阳市', '411400': '商丘市', '411500': '信阳市', '411600': '周口市',
        '411700': '驻马店市', '419000': '省直辖县级行政区划',
        // 湖北
        '420100': '武汉市', '420200': '黄石市', '420300': '十堰市', '420500': '宜昌市',
        '420600': '襄阳市', '420700': '鄂州市', '420800': '荆门市', '420900': '孝感市',
        '421000': '荆州市', '421100': '黄冈市', '421200': '咸宁市', '421300': '随州市',
        '422800': '恩施土家族苗族自治州', '429000': '省直辖县级行政区划',
        // 湖南
        '430100': '长沙市', '430200': '株洲市', '430300': '湘潭市', '430400': '衡阳市',
        '430500': '邵阳市', '430600': '岳阳市', '430700': '常德市', '430800': '张家界市',
        '430900': '益阳市', '431000': '郴州市', '431100': '永州市', '431200': '怀化市',
        '431300': '娄底市', '433100': '湘西土家族苗族自治州',
        // 广东
        '440100': '广州市', '440200': '韶关市', '440300': '深圳市', '440400': '珠海市',
        '440500': '汕头市', '440600': '佛山市', '440700': '江门市', '440800': '湛江市',
        '440900': '茂名市', '441200': '肇庆市', '441300': '惠州市', '441400': '梅州市',
        '441500': '汕尾市', '441600': '河源市', '441700': '阳江市', '441800': '清远市',
        '441900': '东莞市', '442000': '中山市', '445100': '潮州市', '445200': '揭阳市',
        '445300': '云浮市',
        // 广西
        '450100': '南宁市', '450200': '柳州市', '450300': '桂林市', '450400': '梧州市',
        '450500': '北海市', '450600': '防城港市', '450700': '钦州市', '450800': '贵港市',
        '450900': '玉林市', '451000': '百色市', '451100': '贺州市', '451200': '河池市',
        '451300': '来宾市', '451400': '崇左市',
        // 海南
        '460100': '海口市', '460200': '三亚市', '460300': '三沙市', '460400': '儋州市',
        '469000': '省直辖县级行政区划',
        // 四川
        '510100': '成都市', '510300': '自贡市', '510400': '攀枝花市', '510500': '泸州市',
        '510600': '德阳市', '510700': '绵阳市', '510800': '广元市', '510900': '遂宁市',
        '511000': '内江市', '511100': '乐山市', '511300': '南充市', '511400': '眉山市',
        '511500': '宜宾市', '511600': '广安市', '511700': '达州市', '511800': '雅安市',
        '511900': '巴中市', '512000': '资阳市', '513200': '阿坝藏族羌族自治州',
        '513300': '甘孜藏族自治州', '513400': '凉山彝族自治州',
        // 贵州
        '520100': '贵阳市', '520200': '六盘水市', '520300': '遵义市', '520400': '安顺市',
        '520500': '毕节市', '520600': '铜仁市', '522300': '黔西南布依族苗族自治州',
        '522600': '黔东南苗族侗族自治州', '522700': '黔南布依族苗族自治州',
        // 云南
        '530100': '昆明市', '530300': '曲靖市', '530400': '玉溪市', '530500': '保山市',
        '530600': '昭通市', '530700': '丽江市', '530800': '普洱市', '530900': '临沧市',
        '532300': '楚雄彝族自治州', '532500': '红河哈尼族彝族自治州',
        '532600': '文山壮族苗族自治州', '532800': '西双版纳傣族自治州',
        '532900': '大理白族自治州', '533100': '德宏傣族景颇族自治州',
        '533300': '怒江傈僳族自治州', '533400': '迪庆藏族自治州',
        // 西藏
        '540100': '拉萨市', '540200': '日喀则市', '540300': '昌都市', '540400': '林芝市',
        '540500': '山南市', '540600': '那曲市', '542500': '阿里地区',
        // 陕西
        '610100': '西安市', '610200': '铜川市', '610300': '宝鸡市', '610400': '咸阳市',
        '610500': '渭南市', '610600': '延安市', '610700': '汉中市', '610800': '榆林市',
        '610900': '安康市', '611000': '商洛市',
        // 甘肃
        '620100': '兰州市', '620200': '嘉峪关市', '620300': '金昌市', '620400': '白银市',
        '620500': '天水市', '620600': '武威市', '620700': '张掖市', '620800': '平凉市',
        '620900': '酒泉市', '621000': '庆阳市', '621100': '定西市', '621200': '陇南市',
        '622900': '临夏回族自治州', '623000': '甘南藏族自治州',
        // 青海
        '630100': '西宁市', '630200': '海东市', '632200': '海北藏族自治州',
        '632300': '黄南藏族自治州', '632500': '海南藏族自治州', '632600': '果洛藏族自治州',
        '632700': '玉树藏族自治州', '632800': '海西蒙古族藏族自治州',
        // 宁夏
        '640100': '银川市', '640200': '石嘴山市', '640300': '吴忠市', '640400': '固原市',
        '640500': '中卫市',
        // 新疆
        '650100': '乌鲁木齐市', '650200': '克拉玛依市', '650400': '吐鲁番市', '650500': '哈密市',
        '652300': '昌吉回族自治州', '652700': '博尔塔拉蒙古自治州', '652800': '巴音郭楞蒙古自治州',
        '652900': '阿克苏地区', '653000': '克孜勒苏柯尔克孜自治州', '653100': '喀什地区',
        '653200': '和田地区', '654000': '伊犁哈萨克自治州', '654200': '塔城地区',
        '654300': '阿勒泰地区', '659000': '自治区直辖县级行政区划'
      };
      
      // 合并映射表（区级代码优先级最高，其次是城市代码，最后是省份代码）
      const fullCodeMap = { ...provinceCodeMap, ...cityCodeMap, ...districtCodeMap };
      
      // 递归处理所有层级的数据
      const processData = (item) => {
        if (item.code && (item.stationCount !== undefined || item.connectorCount !== undefined)) {
          const code = String(item.code);
          // 优先使用 fullCodeMap（内置的代码到名称映射），其次使用 this.codeToNameMap（从地图GeoJSON中获取的映射）
          let regionName = fullCodeMap[code] || this.codeToNameMap[code] || item.provinceName || item.name;
          

          
          if (regionName) {
            // 根据接口返回的数据结构，存储完整的地图数据
            newData[regionName] = {
              gunCount: item.connectorCount || 0,
              stationCount: item.stationCount || 0,
              chargeAmount: item.totalElec || 0
            };
          }
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => processData(child));
        }
      };
      
      // 从 data 开始处理（可能是省或全国）
      processData(data);
      

      
      // 一次性替换整个对象，触发响应式更新
      this.mapElecData = newData;
    },
    // 加载地图数据
    loadMapData(mapName, url, onSuccess) {
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then(json => {
          // 检查组件是否仍然存在
          if (!this._isMounted) return;
          
          // 应用标签偏移（上海/北京）
          if (mapName === '上海市' || mapName === '上海' || mapName === '北京市' || mapName === '北京') {
            this.applyLabelOffset(json, mapName);
          }
          
          echarts.registerMap(mapName, json);
          this.mapRegionMap = {};
          this.codeToNameMap = {};
          
          // 构建区域代码映射
          if (json.features) {
            json.features.forEach(feature => {
              const name = feature.properties.name;
              // 尝试多种可能的属性名
              const adcode = feature.properties.id || feature.properties.adcode || feature.properties.code || feature.properties.adcode_str;
              this.mapRegionMap[name] = { adcode, name };
              // 建立代码到名称的映射（用于省份地图）
              if (adcode) {
                this.codeToNameMap[adcode] = name;
                // 也存储字符串格式
                this.codeToNameMap[String(adcode)] = name;
              } else {
                // 对于没有adcode的地图数据（如echarts省份地图），直接使用名称作为key
                this.codeToNameMap[name] = name;
              }
            });
          }
          
          // currentMapRegion 必须与注册地图时的名称一致
          this.currentMapRegion = mapName;
          this.mapLoaded = true;
          
          // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
          this.mapFirstLoad = false;
          this.mapInitialized = true;
          
          // 在地图配置设置完成后，再执行成功回调（用于加载数据）
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess();
          }
        })
        .catch(err => {
          console.error(`加载地图数据失败 [${mapName}]:`, err);
        });
    },
    // 处理地图点击事件
    handleMapClick(params) {
      if (!params || !params.name) return;
      
      const regionName = params.name;
      
      // 全国地图下点击省份
      if (this.mapLevel === 'china') {
        // 检查省份是否在允许的列表中
        if (!this.isProvinceAllowed(regionName)) {
          this.$message({
            message: `抱歉，${regionName}暂不支持地图下钻功能`,
            type: 'warning',
            duration: 3000
          });
          return;
        }
        this.drillDownToProvince(regionName);
      }
      // 省份地图下点击城市
      else if (this.mapLevel === 'province') {
        this.drillDownToCity(regionName);
      }
    },
    
    // 检查省份是否在允许的列表中
    isProvinceAllowed(provinceName) {
      // 允许的省份代码列表（与导航栏选项一致）
      const allowedProvinceCodes = [
        '440000', // 广东省
        '350000', // 福建省
        '340000', // 安徽省
        '450000', // 广西省
        '330000', // 浙江省
        '320000', // 江苏省
        '110000', // 北京
        '310000'  // 上海
      ];
      
      // 获取点击省份的代码
      const provinceCode = this.getProvinceCodeByName(provinceName);
      
      // 检查是否在允许列表中
      const allowed = allowedProvinceCodes.includes(provinceCode);
      return allowed;
    },
    
    // 下钻至省份地图
    drillDownToProvince(provinceName) {
      // 中文省份名到英文文件名的映射（支持多种格式）
      const provinceNameMap = {
        '广东省': 'guangdong',
        '广东': 'guangdong',
        '福建省': 'fujian',
        '福建': 'fujian',
        '安徽省': 'anhui',
        '安徽': 'anhui',
        '广西省': 'guangxi',
        '广西': 'guangxi',
        '广西壮族自治区': 'guangxi',
        '浙江省': 'zhejiang',
        '浙江': 'zhejiang',
        '江苏省': 'jiangsu',
        '江苏': 'jiangsu',
        '北京': 'beijing',
        '北京市': 'beijing',
        '上海': 'shanghai',
        '上海市': 'shanghai'
      };
      
      const englishName = provinceNameMap[provinceName];
      if (!englishName) {
        console.warn(`未找到省份 ${provinceName} 的地图数据，支持的省份:`, Object.keys(provinceNameMap));
        this.$message({
          message: `抱歉，${provinceName}的地图数据暂时不可用`,
          type: 'warning',
          duration: 3000
        });
        return;
      }
      
      const provinceUrl = `https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/province/${englishName}.json`;
      
      // 更新状态
      this.currentProvince = provinceName;
      this.currentProvinceCode = this.getProvinceCodeByName(provinceName);
      this.mapLevel = 'province';
      // 切换地图级别时重置用户的缩放和位移状态，恢复初始状态
      this.mapUserState = { zoom: null, center: null };
      this.mapFirstLoad = true; // 重置首次加载标记
      this.mapInitialized = false;
      
      // 同步更新搜索栏所属区域
      this.region = this.currentProvinceCode;
      
      // 加载省份地图，地图加载完成后再获取数据
      this.loadProvinceMap(provinceName, provinceUrl, () => {
        this.fetchMapData(this.currentProvinceCode);
      });
    },
    
    // 下钻至城市地图
    drillDownToCity(cityName) {
      // 获取城市代码
      const cityCode = this.getCityCodeByName(cityName);
      
      if (!cityCode) {
        console.warn(`未找到城市 ${cityName} 的代码`);
        return;
      }
      
      // 更新状态
      this.currentCity = cityName;
      this.mapLevel = 'city';
      
      // 切换地图级别时重置用户的缩放和位移状态，恢复初始状态
      this.mapUserState = { zoom: null, center: null };
      this.mapFirstLoad = true; // 重置首次加载标记
      this.mapInitialized = false;
      
      // 使用多个备用源加载城市地图（按优先级尝试）
      // 优先使用本地数据，其次使用在线数据源
      const cityUrls = [
        `${process.env.BASE_URL || '/cloud/'}geojson/city/${cityCode}.json`, // 本地数据源（优先）
        `https://geo.datav.aliyun.com/areas_v3/bound/${cityCode}.json`,
        `https://geo.datav.aliyun.com/areas_v3/bound/${cityCode}_full.json`,
        `https://cdn.jsdelivr.net/gh/lyhmyd1211/GeoMapData_CN@master/city/${cityCode}.json`,
        `https://raw.githubusercontent.com/lyhmyd1211/GeoMapData_CN/master/city/${cityCode}.json`,
        `https://geojson.cn/api/china/1.6.3/${cityCode}.json` // geojson.cn 数据源
      ];
      
      // 尝试从多个源加载城市地图，地图加载完成后再获取数据
      this.loadCityMapFromMultipleSources(cityName, cityUrls, () => {
        this.fetchMapData(cityCode);
      });
    },
    
    // 应用标签偏移，避免区名重叠
    applyLabelOffset(json, provinceName) {
      if (!json || !json.features) return;
      
      const shanghaiOffset = {
        '杨浦区': [0, 0.08],
        '浦东新区': [0.15, -0.1],
        '虹口区': [0, 0.05],
        '静安区': [0, 0.05],
        '长宁区': [-0.05, 0],
        '黄浦区': [0, -0.05],
        '普陀区': [0, 0.05],
        '徐汇区': [-0.05, -0.05],
        '闵行区': [0, -0.08],
        '宝山区': [0, 0.05],
        '嘉定区': [-0.05, 0.05],
        '松江区': [-0.05, -0.05],
        '青浦区': [-0.08, 0],
        '奉贤区': [0, -0.05],
        '金山区': [-0.05, -0.05]
      };
      
      const beijingOffset = {
        '门头沟区': [-0.08, 0],
        '海淀区': [-0.06, 0.06],
        '朝阳区': [0.08, 0.06],
        '东城区': [0, -0.05],
        '西城区': [-0.05, -0.05],
        '丰台区': [0, -0.08],
        '石景山区': [-0.06, 0],
        '房山区': [0, -0.08],
        '通州区': [0.06, 0],
        '顺义区': [0.05, 0.05],
        '昌平区': [0, 0.06],
        '大兴区': [0, -0.06],
        '怀柔区': [0.05, 0.08],
        '平谷区': [0.08, 0],
        '密云区': [0.06, 0.06],
        '延庆区': [-0.06, 0.08]
      };
      
      const labelCenterOffset = (provinceName === '上海市' || provinceName === '上海') 
        ? shanghaiOffset 
        : beijingOffset;
      
      json.features.forEach(feature => {
        const name = feature.properties.name;
        if (labelCenterOffset[name]) {
          const offset = labelCenterOffset[name];
          if (feature.properties.center) {
            feature.properties.center = [
              feature.properties.center[0] + offset[0],
              feature.properties.center[1] + offset[1]
            ];
          }
          if (feature.properties.cp) {
            feature.properties.cp = [
              feature.properties.cp[0] + offset[0],
              feature.properties.cp[1] + offset[1]
            ];
          }
        }
      });
    },
    
    // 加载省份地图
    loadProvinceMap(provinceName, url, onSuccess) {
      // 检查缓存
      if (this.provinceGeoJsonCache[provinceName]) {
        // 深拷贝缓存数据，避免修改原始缓存
        const json = JSON.parse(JSON.stringify(this.provinceGeoJsonCache[provinceName]));
        
        // 应用标签偏移（上海）
        if (provinceName === '上海市' || provinceName === '上海') {
          this.applyLabelOffset(json, provinceName);
        }
        // 应用标签偏移（北京）
        if (provinceName === '北京市' || provinceName === '北京') {
          this.applyLabelOffset(json, provinceName);
        }
        
        echarts.registerMap(provinceName, json);
        this.currentMapRegion = provinceName;
        this.mapLoaded = true;
        
        // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
        this.mapFirstLoad = false;
        this.mapInitialized = true;
        
        // 执行回调加载数据
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess();
        }
        return;
      }
      
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then(json => {
          // 检查组件是否仍然存在
          if (!this._isMounted) return;
          
          // 先缓存原始GeoJSON（未偏移）
          this.provinceGeoJsonCache[provinceName] = JSON.parse(JSON.stringify(json));
          
          // 应用标签偏移（上海/北京）
          if (provinceName === '上海市' || provinceName === '上海' || provinceName === '北京市' || provinceName === '北京') {
            this.applyLabelOffset(json, provinceName);
          }
          
          echarts.registerMap(provinceName, json);
          
          // 构建代码到名称的映射
          this.codeToNameMap = {};
          if (json.features) {
            json.features.forEach(feature => {
              const name = feature.properties.name;
              const adcode = feature.properties.adcode || feature.properties.id;
              if (adcode) {
                this.codeToNameMap[String(adcode)] = name;
              } else {
                // 对于没有adcode的地图数据（如echarts省份地图），直接使用名称作为key
                this.codeToNameMap[name] = name;
              }
            });
          }
          
          this.currentMapRegion = provinceName;
          this.mapLoaded = true;
          
          // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
          this.mapFirstLoad = false;
          this.mapInitialized = true;
          
          // 执行回调加载数据
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess();
          }
        })
        .catch(err => {
          console.error(`加载省份地图数据失败 [${provinceName}]:`, err);
        });
    },
    
    // 加载城市地图
    loadCityMap(cityName, url, onSuccess) {
      // 检查缓存
      if (this.cityGeoJsonCache[cityName]) {
        echarts.registerMap(cityName, this.cityGeoJsonCache[cityName]);
        this.currentMapRegion = cityName;
        this.mapLoaded = true;
        
        // 重新构建代码到名称的映射（重要：缓存命中时也需要更新）
        const json = this.cityGeoJsonCache[cityName];
        this.codeToNameMap = {};
        if (json.features) {
          json.features.forEach(feature => {
            const name = feature.properties.name;
            const adcode = feature.properties.adcode || feature.properties.id;
            if (adcode) {
              this.codeToNameMap[String(adcode)] = name;
            } else {
              this.codeToNameMap[name] = name;
            }
          });
        }
        
        // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
        this.mapFirstLoad = false;
        this.mapInitialized = true;
        
        // 执行回调加载数据
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess();
        }
        return;
      }
      
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then(json => {
          // 检查组件是否仍然存在
          if (!this._isMounted) return;
          
          // 缓存GeoJSON
          this.cityGeoJsonCache[cityName] = json;
          echarts.registerMap(cityName, json);
          
          // 构建代码到名称的映射
          this.codeToNameMap = {};
          if (json.features) {
            json.features.forEach(feature => {
              const name = feature.properties.name;
              const adcode = feature.properties.adcode || feature.properties.id;
              if (adcode) {
                this.codeToNameMap[String(adcode)] = name;
              } else {
                // 对于没有adcode的地图数据（如echarts省份地图），直接使用名称作为key
                this.codeToNameMap[name] = name;
              }
            });
          }
          
          this.currentMapRegion = cityName;
          this.mapLoaded = true;
          
          // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
          this.mapFirstLoad = false;
          this.mapInitialized = true;
          
          // 使用 $nextTick 确保响应式更新完成后再执行回调
          this.$nextTick(() => {
            // 执行回调加载数据
            if (onSuccess && typeof onSuccess === 'function') {
              onSuccess();
            }
          });
        })
        .catch(err => {
          console.error(`加载城市地图数据失败 [${cityName}]:`, err);
        });
    },
    
    // 从多个备用源加载城市地图
    loadCityMapFromMultipleSources(cityName, urls, onSuccess) {
      // 检查缓存
      if (this.cityGeoJsonCache[cityName]) {
        echarts.registerMap(cityName, this.cityGeoJsonCache[cityName]);
        this.currentMapRegion = cityName;
        this.mapLoaded = true;
        
        // 重新构建代码到名称的映射（重要：缓存命中时也需要更新）
        const json = this.cityGeoJsonCache[cityName];
        this.codeToNameMap = {};
        if (json.features) {
          json.features.forEach(feature => {
            const name = feature.properties.name;
            const adcode = feature.properties.adcode || feature.properties.id;
            if (adcode) {
              this.codeToNameMap[String(adcode)] = name;
            } else {
              this.codeToNameMap[name] = name;
            }
          });
        }
        
        // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
        this.mapFirstLoad = false;
        this.mapInitialized = true;
        
        // 使用 $nextTick 确保响应式更新完成后再执行回调
        this.$nextTick(() => {
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess();
          }
        });
        return;
      }
      
      // 递归尝试多个URL
      const tryLoad = (index) => {
        if (index >= urls.length) {
          console.error(`所有地图数据源均加载失败 [${cityName}]`);
          // 检查组件是否仍然存在
          if (!this._isMounted) return;
          // 显示友好提示
          this.$message({
            message: `抱歉，${cityName}的地图数据暂时不可用。请联系管理员添加本地地图数据文件：public/geojson/city/${this.getCityCodeByName(cityName)}.json`,
            type: 'warning',
            duration: 5000
          });
          // 返回上一级
          setTimeout(() => {
            if (this._isMounted) {
              this.backToProvinceMap();
            }
          }, 1000);
          return;
        }
        
        const url = urls[index];
        
        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
          })
          .then(json => {
            // 检查组件是否仍然存在
            if (!this._isMounted) return;
            
            // 验证GeoJSON数据是否有效
            if (!json.features || json.features.length === 0) {
              throw new Error('无效的GeoJSON数据');
            }
            
            // 缓存GeoJSON
            this.cityGeoJsonCache[cityName] = json;
            echarts.registerMap(cityName, json);
            
            this.currentMapRegion = cityName;
            this.mapLoaded = true;
            
            // 构建代码到名称的映射
            this.codeToNameMap = {};
            if (json.features) {
              json.features.forEach(feature => {
                const name = feature.properties.name;
                const adcode = feature.properties.adcode || feature.properties.id;
                if (adcode) {
                  this.codeToNameMap[String(adcode)] = name;
                } else {
                  // 对于没有adcode的地图数据（如echarts省份地图），直接使用名称作为key
                  this.codeToNameMap[name] = name;
                }
              });
            }
            

            
            // 标记首次加载完成，mapOption 计算属性会自动触发地图渲染
            this.mapFirstLoad = false;
            this.mapInitialized = true;
            
            // 使用 $nextTick 确保响应式更新完成后再执行回调
            this.$nextTick(() => {
              // 执行回调加载数据
              if (onSuccess && typeof onSuccess === 'function') {
                onSuccess();
              }
            });
          })
          .catch(err => {
            console.warn(`从 ${url} 加载城市地图失败 [${cityName}]:`, err.message);
            // 尝试下一个URL
            tryLoad(index + 1);
          });
      };
      
      // 从第一个URL开始尝试
      tryLoad(0);
    },
    
    // 返回省份地图
    backToProvinceMap() {
      if (!this.currentProvince || !this.currentProvinceCode) return;
      
      // 切换地图级别时重置用户的缩放和位移状态，恢复初始状态
      this.mapUserState = { zoom: null, center: null };
      this.mapFirstLoad = true; // 重置首次加载标记
      this.mapInitialized = false;
      
      const provinceNameMap = {
        '广东省': 'guangdong',
        '福建省': 'fujian',
        '安徽省': 'anhui',
        '广西省': 'guangxi',
        '浙江省': 'zhejiang',
        '江苏省': 'jiangsu',
        '北京': 'beijing',
        '上海': 'shanghai'
      };
      
      const englishName = provinceNameMap[this.currentProvince];
      if (!englishName) {
        // 如果不在常用映射中，使用 GitHub + jsDelivr CDN 加载（替代已失效的阿里云 DataV GeoAtlas API）
        const provinceUrl = `https://cdn.jsdelivr.net/gh/lyhmyd1211/GeoMapData_CN@master/province/${this.currentProvinceCode}.json`;
        this.currentCity = '';
        this.mapLevel = 'province';
        this.loadProvinceMap(this.currentProvince, provinceUrl);
        this.fetchMapData(this.currentProvinceCode);
        return;
      }
      
      const provinceUrl = `https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/province/${englishName}.json`;
      
      this.currentCity = '';
      this.mapLevel = 'province';
      
      this.loadProvinceMap(this.currentProvince, provinceUrl);
      this.fetchMapData(this.currentProvinceCode);
    },
    
    // 返回全国地图
    backToChinaMap() {
      this.currentProvince = '';
      this.currentCity = '';
      this.currentProvinceCode = '';
      this.mapLevel = 'china';
      // 切换地图级别时重置用户的缩放和位移状态，恢复初始状态
      this.mapUserState = { zoom: null, center: null };
      this.mapFirstLoad = true; // 重置首次加载标记
      this.mapInitialized = false;
      
      // 同步更新搜索栏所属区域为全国
      this.region = '';
      
      this.loadMapData('china', 'https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/china.json');
      this.fetchMapData('');
    },
    
    // 根据省份名称获取省份代码
    getProvinceCodeByName(provinceName) {
      const codeMap = {
        // 支持带"省"和不带"省"的两种格式
        '北京': '110000',
        '北京市': '110000',
        '天津': '120000',
        '天津市': '120000',
        '河北': '130000',
        '河北省': '130000',
        '山西': '140000',
        '山西省': '140000',
        '内蒙古': '150000',
        '内蒙古自治区': '150000',
        '辽宁': '210000',
        '辽宁省': '210000',
        '吉林': '220000',
        '吉林省': '220000',
        '黑龙江': '230000',
        '黑龙江省': '230000',
        '上海': '310000',
        '上海市': '310000',
        '江苏': '320000',
        '江苏省': '320000',
        '浙江': '330000',
        '浙江省': '330000',
        '安徽': '340000',
        '安徽省': '340000',
        '福建': '350000',
        '福建省': '350000',
        '江西': '360000',
        '江西省': '360000',
        '山东': '370000',
        '山东省': '370000',
        '河南': '410000',
        '河南省': '410000',
        '湖北': '420000',
        '湖北省': '420000',
        '湖南': '430000',
        '湖南省': '430000',
        '广东': '440000',
        '广东省': '440000',
        '广西': '450000',
        '广西省': '450000',
        '广西壮族自治区': '450000',
        '海南': '460000',
        '海南省': '460000',
        '重庆': '500000',
        '重庆市': '500000',
        '四川': '510000',
        '四川省': '510000',
        '贵州': '520000',
        '贵州省': '520000',
        '云南': '530000',
        '云南省': '530000',
        '西藏': '540000',
        '西藏自治区': '540000',
        '陕西': '610000',
        '陕西省': '610000',
        '甘肃': '620000',
        '甘肃省': '620000',
        '青海': '630000',
        '青海省': '630000',
        '宁夏': '640000',
        '宁夏回族自治区': '640000',
        '新疆': '650000',
        '新疆维吾尔自治区': '650000',
        '台湾': '710000',
        '台湾省': '710000',
        '香港': '810000',
        '香港特别行政区': '810000',
        '澳门': '820000',
        '澳门特别行政区': '820000'
      };
      return codeMap[provinceName] || '';
    },
    
    // 获取地区中心坐标（用于涟漪散点显示）
    getRegionCenter(regionName) {
      // 省份中心坐标
      const provinceCenters = {
        '新疆': [85.0, 41.0],
        '西藏': [88.0, 32.0],
        '青海': [96.0, 35.0],
        '甘肃': [103.0, 36.0],
        '内蒙古': [113.0, 44.0],
        '宁夏': [106.0, 37.0],
        '黑龙江': [128.0, 47.0],
        '吉林': [126.0, 43.0],
        '辽宁': [123.0, 41.0],
        '河北': [115.0, 39.0],
        '北京': [116.4, 40.1],
        '天津': [117.2, 39.1],
        '山西': [112.0, 37.0],
        '陕西': [109.0, 35.0],
        '山东': [118.0, 36.0],
        '河南': [113.0, 34.0],
        '江苏': [119.0, 33.0],
        '安徽': [117.0, 32.0],
        '浙江': [120.0, 29.0],
        '上海': [121.5, 31.2],
        '湖北': [112.0, 31.0],
        '湖南': [112.0, 27.0],
        '江西': [116.0, 27.0],
        '福建': [118.0, 26.0],
        '广东': [113.5, 23.0],
        '广西': [108.5, 23.5],
        '海南': [109.8, 19.2],
        '四川': [104.0, 30.0],
        '重庆': [106.5, 29.5],
        '贵州': [106.0, 27.0],
        '云南': [102.0, 25.0],
        '台湾': [121.0, 23.5]
      };
      
      // 城市中心坐标（部分主要城市）
      const cityCenters = {
        '北京市': [116.4, 40.1],
        '天津市': [117.2, 39.1],
        '上海市': [121.5, 31.2],
        '重庆市': [106.5, 29.5],
        '石家庄市': [114.5, 38.0],
        '唐山市': [118.2, 39.6],
        '秦皇岛市': [119.6, 39.9],
        '邯郸市': [114.5, 36.6],
        '邢台市': [114.5, 37.1],
        '保定市': [115.5, 38.9],
        '张家口市': [114.9, 40.8],
        '承德市': [117.9, 40.9],
        '沧州市': [116.9, 38.3],
        '廊坊市': [116.7, 39.5],
        '衡水市': [115.7, 37.7],
        '太原市': [112.5, 37.8],
        '大同市': [113.3, 40.1],
        '阳泉市': [113.6, 37.9],
        '长治市': [113.1, 36.2],
        '晋城市': [112.8, 35.5],
        '朔州市': [112.4, 39.3],
        '晋中市': [112.7, 37.7],
        '运城市': [111.0, 35.0],
        '忻州市': [112.7, 38.4],
        '临汾市': [111.5, 36.1],
        '吕梁市': [111.1, 37.5],
        '沈阳市': [123.4, 41.8],
        '大连市': [121.6, 38.9],
        '鞍山市': [123.0, 41.1],
        '抚顺市': [123.9, 41.9],
        '本溪市': [123.8, 41.3],
        '丹东市': [124.4, 40.1],
        '锦州市': [121.1, 41.1],
        '营口市': [122.2, 40.7],
        '阜新市': [121.7, 42.0],
        '辽阳市': [123.2, 41.3],
        '盘锦市': [122.1, 41.1],
        '铁岭市': [123.8, 42.3],
        '朝阳市': [120.5, 41.6],
        '葫芦岛市': [120.8, 40.8],
        '长春市': [125.3, 43.8],
        '吉林市': [126.5, 43.8],
        '四平市': [124.4, 43.2],
        '辽源市': [125.1, 42.9],
        '通化市': [125.9, 41.7],
        '白山市': [126.4, 41.9],
        '松原市': [124.8, 45.1],
        '白城市': [122.8, 45.6],
        '哈尔滨市': [126.6, 45.8],
        '齐齐哈尔市': [123.9, 47.3],
        '鸡西市': [130.9, 45.3],
        '鹤岗市': [130.3, 47.3],
        '双鸭山市': [131.2, 46.6],
        '大庆市': [125.1, 46.6],
        '伊春市': [128.9, 47.7],
        '佳木斯市': [130.3, 46.8],
        '七台河市': [131.0, 45.8],
        '牡丹江市': [129.6, 44.6],
        '黑河市': [127.5, 50.2],
        '绥化市': [126.9, 46.6],
        '南京市': [118.8, 32.0],
        '无锡市': [120.3, 31.6],
        '徐州市': [117.2, 34.3],
        '常州市': [119.9, 31.8],
        '苏州市': [120.6, 31.3],
        '南通市': [120.9, 32.0],
        '连云港市': [119.2, 34.6],
        '淮安市': [119.0, 33.5],
        '盐城市': [120.1, 33.4],
        '扬州市': [119.4, 32.4],
        '镇江市': [119.5, 32.2],
        '泰州市': [119.9, 32.5],
        '宿迁市': [118.3, 33.9],
        '杭州市': [120.2, 30.3],
        '宁波市': [121.5, 29.9],
        '温州市': [120.7, 28.0],
        '嘉兴市': [120.8, 30.8],
        '湖州市': [120.1, 30.9],
        '绍兴市': [120.6, 30.0],
        '金华市': [119.6, 29.1],
        '衢州市': [118.9, 28.9],
        '舟山市': [122.1, 30.0],
        '台州市': [121.4, 28.7],
        '丽水市': [119.9, 28.5],
        '合肥市': [117.3, 31.8],
        '芜湖市': [118.4, 31.3],
        '蚌埠市': [117.4, 32.9],
        '淮南市': [117.0, 32.6],
        '马鞍山市': [118.5, 31.7],
        '淮北市': [116.8, 33.9],
        '铜陵市': [117.8, 30.9],
        '安庆市': [117.0, 30.5],
        '黄山市': [118.3, 29.7],
        '滁州市': [118.3, 32.3],
        '阜阳市': [115.8, 32.9],
        '宿州市': [116.9, 33.6],
        '六安市': [116.5, 31.8],
        '亳州市': [115.8, 33.9],
        '池州市': [117.5, 30.7],
        '宣城市': [118.8, 30.9],
        '福州市': [119.3, 26.1],
        '厦门市': [118.1, 24.5],
        '莆田市': [119.0, 25.4],
        '三明市': [117.6, 26.3],
        '泉州市': [118.6, 24.9],
        '漳州市': [117.6, 24.5],
        '南平市': [118.2, 26.6],
        '龙岩市': [117.0, 25.1],
        '宁德市': [119.5, 26.7],
        '济南市': [117.0, 36.7],
        '青岛市': [120.4, 36.1],
        '淄博市': [118.0, 36.8],
        '枣庄市': [117.6, 34.9],
        '东营市': [118.5, 37.5],
        '烟台市': [121.4, 37.5],
        '潍坊市': [119.1, 36.7],
        '济宁市': [116.6, 35.4],
        '泰安市': [117.1, 36.2],
        '威海市': [122.1, 37.5],
        '日照市': [119.5, 35.4],
        '临沂市': [118.4, 35.1],
        '德州市': [116.3, 37.4],
        '聊城市': [115.9, 36.5],
        '滨州市': [118.0, 37.4],
        '菏泽市': [115.4, 35.2],
        '郑州市': [113.7, 34.8],
        '开封市': [114.3, 34.8],
        '洛阳市': [112.5, 34.7],
        '平顶山市': [113.3, 33.8],
        '安阳市': [114.4, 36.1],
        '鹤壁市': [114.3, 35.9],
        '新乡市': [113.9, 35.3],
        '焦作市': [113.2, 35.2],
        '濮阳市': [115.0, 35.8],
        '许昌市': [113.8, 34.0],
        '漯河市': [114.0, 33.6],
        '三门峡市': [111.2, 34.8],
        '南阳市': [112.5, 33.0],
        '商丘市': [115.6, 34.4],
        '信阳市': [114.1, 32.1],
        '周口市': [114.7, 33.6],
        '驻马店市': [114.0, 33.0],
        '武汉市': [114.3, 30.6],
        '黄石市': [115.0, 30.2],
        '十堰市': [110.8, 32.6],
        '宜昌市': [111.3, 30.7],
        '襄阳市': [112.1, 32.0],
        '鄂州市': [114.9, 30.4],
        '荆门市': [112.2, 31.0],
        '孝感市': [113.9, 30.9],
        '荆州市': [112.2, 30.3],
        '黄冈市': [114.9, 30.4],
        '咸宁市': [114.3, 29.9],
        '随州市': [113.4, 31.7],
        '恩施土家族苗族自治州': [109.5, 30.3],
        '长沙市': [112.9, 28.2],
        '株洲市': [113.1, 27.8],
        '湘潭市': [112.9, 27.8],
        '衡阳市': [112.6, 26.9],
        '邵阳市': [111.5, 27.2],
        '岳阳市': [113.1, 29.4],
        '常德市': [111.7, 29.0],
        '张家界市': [110.5, 29.1],
        '益阳市': [112.3, 28.6],
        '郴州市': [113.0, 25.8],
        '永州市': [111.6, 26.4],
        '怀化市': [110.0, 27.6],
        '娄底市': [112.0, 27.7],
        '湘西土家族苗族自治州': [109.7, 28.3],
        '南昌市': [115.9, 28.7],
        '景德镇市': [117.2, 29.3],
        '萍乡市': [113.9, 27.6],
        '九江市': [116.0, 29.7],
        '新余市': [114.9, 27.8],
        '鹰潭市': [117.0, 28.2],
        '赣州市': [114.9, 25.9],
        '吉安市': [114.9, 27.1],
        '宜春市': [114.4, 27.8],
        '抚州市': [116.4, 27.9],
        '上饶市': [117.9, 28.4],
        '广州市': [113.3, 23.1],
        '深圳市': [114.1, 22.5],
        '珠海市': [113.6, 22.3],
        '汕头市': [116.7, 23.4],
        '佛山市': [113.1, 23.0],
        '韶关市': [113.6, 24.8],
        '湛江市': [110.4, 21.3],
        '肇庆市': [112.5, 23.1],
        '江门市': [113.1, 22.6],
        '茂名市': [110.9, 21.7],
        '惠州市': [114.4, 23.1],
        '梅州市': [116.1, 24.3],
        '汕尾市': [115.4, 22.8],
        '河源市': [114.7, 23.8],
        '阳江市': [112.0, 21.9],
        '清远市': [113.0, 24.3],
        '东莞市': [113.8, 23.0],
        '中山市': [113.4, 22.5],
        '潮州市': [116.6, 23.7],
        '揭阳市': [116.4, 23.5],
        '云浮市': [112.0, 22.9],
        '南宁市': [108.3, 22.8],
        '柳州市': [109.4, 24.3],
        '桂林市': [110.3, 25.3],
        '梧州市': [111.3, 23.5],
        '北海市': [109.1, 21.5],
        '防城港市': [108.3, 21.8],
        '钦州市': [108.6, 22.0],
        '贵港市': [109.6, 23.1],
        '玉林市': [110.2, 22.6],
        '百色市': [106.6, 23.9],
        '贺州市': [111.6, 24.4],
        '河池市': [108.1, 24.7],
        '来宾市': [109.2, 23.8],
        '崇左市': [107.4, 22.4],
        '海口市': [110.3, 20.0],
        '三亚市': [109.5, 18.3],
        '三沙市': [112.3, 16.8],
        '儋州市': [109.6, 19.5],
        '成都市': [104.1, 30.6],
        '自贡市': [104.8, 29.4],
        '攀枝花市': [101.7, 26.6],
        '泸州市': [105.4, 28.9],
        '德阳市': [104.4, 31.1],
        '绵阳市': [104.7, 31.5],
        '广元市': [105.8, 32.4],
        '遂宁市': [105.6, 30.5],
        '内江市': [105.1, 29.6],
        '乐山市': [103.8, 29.6],
        '南充市': [106.1, 30.8],
        '眉山市': [103.8, 30.0],
        '宜宾市': [104.6, 28.8],
        '广安市': [106.6, 30.5],
        '达州市': [107.5, 31.2],
        '雅安市': [103.0, 29.9],
        '巴中市': [106.8, 31.9],
        '资阳市': [104.6, 30.1],
        '阿坝藏族羌族自治州': [102.2, 31.9],
        '甘孜藏族自治州': [101.9, 30.0],
        '凉山彝族自治州': [102.3, 27.9],
        '贵阳市': [106.7, 26.6],
        '六盘水市': [104.8, 26.6],
        '遵义市': [106.9, 27.7],
        '安顺市': [105.9, 26.2],
        '毕节市': [105.3, 27.3],
        '铜仁市': [109.2, 27.7],
        '黔西南布依族苗族自治州': [104.9, 25.1],
        '黔东南苗族侗族自治州': [107.9, 26.6],
        '黔南布依族苗族自治州': [107.5, 26.3],
        '昆明市': [102.7, 25.0],
        '曲靖市': [103.8, 25.5],
        '玉溪市': [102.5, 24.4],
        '保山市': [99.2, 25.1],
        '昭通市': [103.7, 27.3],
        '丽江市': [100.2, 26.9],
        '普洱市': [101.0, 22.8],
        '临沧市': [100.1, 23.9],
        '楚雄彝族自治州': [101.5, 25.0],
        '红河哈尼族彝族自治州': [103.4, 23.4],
        '文山壮族苗族自治州': [104.2, 23.4],
        '西双版纳傣族自治州': [100.8, 22.0],
        '大理白族自治州': [100.2, 25.6],
        '德宏傣族景颇族自治州': [98.6, 24.4],
        '怒江傈僳族自治州': [98.9, 25.9],
        '迪庆藏族自治州': [99.7, 27.8],
        '西安市': [108.9, 34.3],
        '铜川市': [109.1, 35.1],
        '宝鸡市': [107.1, 34.4],
        '咸阳市': [108.7, 34.3],
        '渭南市': [109.5, 34.5],
        '延安市': [109.5, 36.6],
        '汉中市': [107.0, 33.1],
        '榆林市': [109.7, 38.3],
        '安康市': [109.0, 32.7],
        '商洛市': [109.9, 33.9],
        '兰州市': [103.8, 36.1],
        '嘉峪关市': [98.3, 39.8],
        '金昌市': [102.2, 38.5],
        '白银市': [104.1, 36.5],
        '天水市': [105.7, 34.6],
        '武威市': [102.6, 37.9],
        '张掖市': [100.5, 38.9],
        '平凉市': [106.7, 35.5],
        '酒泉市': [98.5, 39.7],
        '庆阳市': [107.6, 35.7],
        '定西市': [104.6, 35.6],
        '陇南市': [104.9, 33.4],
        '临夏回族自治州': [103.2, 35.6],
        '甘南藏族自治州': [102.9, 34.9],
        '西宁市': [101.8, 36.6],
        '海东市': [102.1, 36.5],
        '海北藏族自治州': [100.9, 37.0],
        '黄南藏族自治州': [102.0, 35.5],
        '海南藏族自治州': [100.6, 36.3],
        '果洛藏族自治州': [100.2, 34.5],
        '玉树藏族自治州': [97.0, 33.0],
        '海西蒙古族藏族自治州': [97.4, 37.4],
        '银川市': [106.3, 38.5],
        '石嘴山市': [106.4, 39.0],
        '吴忠市': [106.2, 37.9],
        '固原市': [106.3, 36.0],
        '中卫市': [105.2, 37.5],
        '乌鲁木齐市': [87.6, 43.8],
        '克拉玛依市': [84.9, 45.6],
        '吐鲁番市': [89.2, 42.9],
        '哈密市': [93.5, 42.8],
        '昌吉回族自治州': [87.3, 44.0],
        '博尔塔拉蒙古自治州': [82.1, 44.9],
        '巴音郭楞蒙古自治州': [86.1, 41.8],
        '阿克苏地区': [80.3, 41.2],
        '克孜勒苏柯尔克孜自治州': [76.2, 39.7],
        '喀什地区': [76.0, 39.5],
        '和田地区': [79.9, 37.1],
        '伊犁哈萨克自治州': [81.3, 43.9],
        '塔城地区': [83.0, 46.7],
        '阿勒泰地区': [88.1, 47.8]
      };
      
      // 广州市各区中心坐标
      const guangzhouDistricts = {
        '荔湾区': [113.23, 23.13],
        '越秀区': [113.27, 23.13],
        '海珠区': [113.32, 23.08],
        '天河区': [113.36, 23.13],
        '白云区': [113.27, 23.25],
        '黄埔区': [113.45, 23.13],
        '番禺区': [113.38, 22.95],
        '花都区': [113.22, 23.40],
        '南沙区': [113.53, 22.78],
        '从化区': [113.58, 23.55],
        '增城区': [113.83, 23.28]
      };
      
      // 北京各区中心坐标
      const beijingDistricts = {
        '东城区': [116.42, 39.93],
        '西城区': [116.37, 39.92],
        '朝阳区': [116.48, 39.95],
        '丰台区': [116.29, 39.86],
        '石景山区': [116.22, 39.91],
        '海淀区': [116.30, 39.96],
        '门头沟区': [116.10, 39.94],
        '房山区': [116.14, 39.75],
        '通州区': [116.66, 39.90],
        '顺义区': [116.65, 40.13],
        '昌平区': [116.23, 40.22],
        '大兴区': [116.34, 39.73],
        '怀柔区': [116.63, 40.32],
        '平谷区': [117.12, 40.14],
        '密云区': [116.84, 40.38],
        '延庆区': [115.97, 40.46]
      };
      
      // 上海各区中心坐标
      const shanghaiDistricts = {
        '黄浦区': [121.48, 31.23],
        '徐汇区': [121.43, 31.18],
        '长宁区': [121.42, 31.22],
        '静安区': [121.45, 31.23],
        '普陀区': [121.40, 31.25],
        '虹口区': [121.49, 31.27],
        '杨浦区': [121.52, 31.26],
        '闵行区': [121.38, 31.11],
        '宝山区': [121.48, 31.40],
        '嘉定区': [121.26, 31.37],
        '浦东新区': [121.54, 31.22],
        '金山区': [121.34, 30.74],
        '松江区': [121.23, 31.03],
        '青浦区': [121.12, 31.15],
        '奉贤区': [121.47, 30.92],
        '崇明区': [121.40, 31.62]
      };
      
      // 先尝试区级坐标，再尝试城市坐标，最后尝试省份坐标
      const hardcodedCenter = beijingDistricts[regionName] || shanghaiDistricts[regionName] || guangzhouDistricts[regionName] || cityCenters[regionName] || provinceCenters[regionName];
      if (hardcodedCenter) {
        return hardcodedCenter;
      }
      
      // 如果硬编码中没有，尝试从当前地图的GeoJSON中获取中心坐标
      const mapName = this.currentMapRegion;
      const mapJson = echarts.getMap(mapName);
      if (mapJson && mapJson.geoJson && mapJson.geoJson.features) {
        const feature = mapJson.geoJson.features.find(f => f.properties.name === regionName);
        if (feature && feature.properties.center) {
          return feature.properties.center;
        }
        // 如果没有center属性，计算bbox的中心
        if (feature && feature.properties.bbox) {
          const bbox = feature.properties.bbox;
          if (bbox && bbox.length === 4) {
            const centerLng = (bbox[0] + bbox[2]) / 2;
            const centerLat = (bbox[1] + bbox[3]) / 2;
            return [centerLng, centerLat];
          }
        }
      }
      
      // 默认返回北京坐标
      return [116.4, 39.9];
    },
    
    // 根据城市名称获取城市代码
    getCityCodeByName(cityName) {
      const cityCodeMap = {
        // 北京
        '北京市': '110100',
        // 天津
        '天津市': '120100',
        // 上海
        '上海市': '310100',
        // 重庆
        '重庆市': '500100',
        // 河北
        '石家庄市': '130100', '唐山市': '130200', '秦皇岛市': '130300', '邯郸市': '130400',
        '邢台市': '130500', '保定市': '130600', '张家口市': '130700', '承德市': '130800',
        '沧州市': '130900', '廊坊市': '131000', '衡水市': '131100',
        // 山西
        '太原市': '140100', '大同市': '140200', '阳泉市': '140300', '长治市': '140400',
        '晋城市': '140500', '朔州市': '140600', '晋中市': '140700', '运城市': '140800',
        '忻州市': '140900', '临汾市': '141000', '吕梁市': '141100',
        // 辽宁
        '沈阳市': '210100', '大连市': '210200', '鞍山市': '210300', '抚顺市': '210400',
        '本溪市': '210500', '丹东市': '210600', '锦州市': '210700', '营口市': '210800',
        '阜新市': '210900', '辽阳市': '211000', '盘锦市': '211100', '铁岭市': '211200',
        '朝阳市': '211300', '葫芦岛市': '211400',
        // 吉林
        '长春市': '220100', '吉林市': '220200', '四平市': '220300', '辽源市': '220400',
        '通化市': '220500', '白山市': '220600', '松原市': '220700', '白城市': '220800',
        '延边朝鲜族自治州': '222400',
        // 黑龙江
        '哈尔滨市': '230100', '齐齐哈尔市': '230200', '鸡西市': '230300', '鹤岗市': '230400',
        '双鸭山市': '230500', '大庆市': '230600', '伊春市': '230700', '佳木斯市': '230800',
        '七台河市': '230900', '牡丹江市': '231000', '黑河市': '231100', '绥化市': '231200',
        '大兴安岭地区': '232700',
        // 江苏
        '南京市': '320100', '无锡市': '320200', '徐州市': '320300', '常州市': '320400',
        '苏州市': '320500', '南通市': '320600', '连云港市': '320700', '淮安市': '320800',
        '盐城市': '320900', '扬州市': '321000', '镇江市': '321100', '泰州市': '321200',
        '宿迁市': '321300',
        // 浙江
        '杭州市': '330100', '宁波市': '330200', '温州市': '330300', '嘉兴市': '330400',
        '湖州市': '330500', '绍兴市': '330600', '金华市': '330700', '衢州市': '330800',
        '舟山市': '330900', '台州市': '331000', '丽水市': '331100',
        // 安徽
        '合肥市': '340100', '芜湖市': '340200', '蚌埠市': '340300', '淮南市': '340400',
        '马鞍山市': '340500', '淮北市': '340600', '铜陵市': '340700', '安庆市': '340800',
        '黄山市': '341000', '滁州市': '341100', '阜阳市': '341200', '宿州市': '341300',
        '六安市': '341500', '亳州市': '341600', '池州市': '341700', '宣城市': '341800',
        // 福建
        '福州市': '350100', '厦门市': '350200', '莆田市': '350300', '三明市': '350400',
        '泉州市': '350500', '漳州市': '350600', '南平市': '350700', '龙岩市': '350800',
        '宁德市': '350900',
        // 江西
        '南昌市': '360100', '景德镇市': '360200', '萍乡市': '360300', '九江市': '360400',
        '新余市': '360500', '鹰潭市': '360600', '赣州市': '360700', '吉安市': '360800',
        '宜春市': '360900', '抚州市': '361000', '上饶市': '361100',
        // 山东
        '济南市': '370100', '青岛市': '370200', '淄博市': '370300', '枣庄市': '370400',
        '东营市': '370500', '烟台市': '370600', '潍坊市': '370700', '济宁市': '370800',
        '泰安市': '370900', '威海市': '371000', '日照市': '371100', '临沂市': '371300',
        '德州市': '371400', '聊城市': '371500', '滨州市': '371600', '菏泽市': '371700',
        // 河南
        '郑州市': '410100', '开封市': '410200', '洛阳市': '410300', '平顶山市': '410400',
        '安阳市': '410500', '鹤壁市': '410600', '新乡市': '410700', '焦作市': '410800',
        '濮阳市': '410900', '许昌市': '411000', '漯河市': '411100', '三门峡市': '411200',
        '南阳市': '411300', '商丘市': '411400', '信阳市': '411500', '周口市': '411600',
        '驻马店市': '411700',
        // 湖北
        '武汉市': '420100', '黄石市': '420200', '十堰市': '420300', '宜昌市': '420500',
        '襄阳市': '420600', '鄂州市': '420700', '荆门市': '420800', '孝感市': '420900',
        '荆州市': '421000', '黄冈市': '421100', '咸宁市': '421200', '随州市': '421300',
        '恩施土家族苗族自治州': '422800',
        // 湖南
        '长沙市': '430100', '株洲市': '430200', '湘潭市': '430300', '衡阳市': '430400',
        '邵阳市': '430500', '岳阳市': '430600', '常德市': '430700', '张家界市': '430800',
        '益阳市': '430900', '郴州市': '431000', '永州市': '431100', '怀化市': '431200',
        '娄底市': '431300', '湘西土家族苗族自治州': '433100',
        // 广东
        '广州市': '440100', '韶关市': '440200', '深圳市': '440300', '珠海市': '440400',
        '汕头市': '440500', '佛山市': '440600', '江门市': '440700', '湛江市': '440800',
        '茂名市': '440900', '肇庆市': '441200', '惠州市': '441300', '梅州市': '441400',
        '汕尾市': '441500', '河源市': '441600', '阳江市': '441700', '清远市': '441800',
        '东莞市': '441900', '中山市': '442000', '潮州市': '445100', '揭阳市': '445200',
        '云浮市': '445300',
        // 广西
        '南宁市': '450100', '柳州市': '450200', '桂林市': '450300', '梧州市': '450400',
        '北海市': '450500', '防城港市': '450600', '钦州市': '450700', '贵港市': '450800',
        '玉林市': '450900', '百色市': '451000', '贺州市': '451100', '河池市': '451200',
        '来宾市': '451300', '崇左市': '451400',
        // 海南
        '海口市': '460100', '三亚市': '460200', '三沙市': '460300', '儋州市': '460400',
        // 四川
        '成都市': '510100', '自贡市': '510300', '攀枝花市': '510400', '泸州市': '510500',
        '德阳市': '510600', '绵阳市': '510700', '广元市': '510800', '遂宁市': '510900',
        '内江市': '511000', '乐山市': '511100', '南充市': '511300', '眉山市': '511400',
        '宜宾市': '511500', '广安市': '511600', '达州市': '511700', '雅安市': '511800',
        '巴中市': '511900', '资阳市': '512000', '阿坝藏族羌族自治州': '513200',
        '甘孜藏族自治州': '513300', '凉山彝族自治州': '513400',
        // 贵州
        '贵阳市': '520100', '六盘水市': '520200', '遵义市': '520300', '安顺市': '520400',
        '毕节市': '520500', '铜仁市': '520600', '黔西南布依族苗族自治州': '522300',
        '黔东南苗族侗族自治州': '522600', '黔南布依族苗族自治州': '522700',
        // 云南
        '昆明市': '530100', '曲靖市': '530300', '玉溪市': '530400', '保山市': '530500',
        '昭通市': '530600', '丽江市': '530700', '普洱市': '530800', '临沧市': '530900',
        '楚雄彝族自治州': '532300', '红河哈尼族彝族自治州': '532500',
        '文山壮族苗族自治州': '532600', '西双版纳傣族自治州': '532800',
        '大理白族自治州': '532900', '德宏傣族景颇族自治州': '533100',
        '怒江傈僳族自治州': '533300', '迪庆藏族自治州': '533400',
        // 西藏
        '拉萨市': '540100', '日喀则市': '540200', '昌都市': '540300', '林芝市': '540400',
        '山南市': '540500', '那曲市': '540600', '阿里地区': '542500',
        // 陕西
        '西安市': '610100', '铜川市': '610200', '宝鸡市': '610300', '咸阳市': '610400',
        '渭南市': '610500', '延安市': '610600', '汉中市': '610700', '榆林市': '610800',
        '安康市': '610900', '商洛市': '611000',
        // 甘肃
        '兰州市': '620100', '嘉峪关市': '620200', '金昌市': '620300', '白银市': '620400',
        '天水市': '620500', '武威市': '620600', '张掖市': '620700', '平凉市': '620800',
        '酒泉市': '620900', '庆阳市': '621000', '定西市': '621100', '陇南市': '621200',
        '临夏回族自治州': '622900', '甘南藏族自治州': '623000',
        // 青海
        '西宁市': '630100', '海东市': '630200', '海北藏族自治州': '632200',
        '黄南藏族自治州': '632300', '海南藏族自治州': '632500', '果洛藏族自治州': '632600',
        '玉树藏族自治州': '632700', '海西蒙古族藏族自治州': '632800',
        // 宁夏
        '银川市': '640100', '石嘴山市': '640200', '吴忠市': '640300', '固原市': '640400',
        '中卫市': '640500',
        // 新疆
        '乌鲁木齐市': '650100', '克拉玛依市': '650200', '吐鲁番市': '650400', '哈密市': '650500',
        '昌吉回族自治州': '652300', '博尔塔拉蒙古自治州': '652700', '巴音郭楞蒙古自治州': '652800',
        '阿克苏地区': '652900', '克孜勒苏柯尔克孜自治州': '653000', '喀什地区': '653100',
        '和田地区': '653200', '伊犁哈萨克自治州': '654000', '塔城地区': '654200',
        '阿勒泰地区': '654300'
      };
      return cityCodeMap[cityName] || '';
    },
    initPeakValleyChart() {
      // 处理充电时段数据，按小时排序
      const hourData = this.peakValleyData.chargingHourDatas || [];
      const sortedData = hourData.sort((a, b) => a.hour - b.hour);
      
      // 生成24小时数据
      const hours = [];
      const data = [];
      const periodTypes = []; // 每个小时对应的时段类型
      
      for (let i = 0; i < 24; i++) {
        hours.push(i.toString().padStart(2, '0') + '时');
        const item = sortedData.find(d => d.hour === i);
        data.push(item ? item.chargingElec : 0);
        periodTypes.push(this.getTimePeriod(i));
      }
      
      // 获取尖峰平谷占比
      const peakRate = this.peakValleyData.peakRate || 0;
      const highRate = this.peakValleyData.highRate || 0;
      const flatRate = this.peakValleyData.flatRate || 0;
      const valleyRate = this.peakValleyData.valleyRate || 0;
      
      // 颜色映射
      const colorMap = {
        peak: '#ff4d4f',
        high: '#1890ff',
        flat: '#faad14',
        valley: '#52c41a'
      };
      
      // 辅助函数：将hex颜色转换为rgba
      const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      };
      
      const periodMap = { peak: '尖段', high: '峰段', flat: '平段', valley: '谷段' };
      
      // 将连续相同时间段的数据分组，每个时间段作为一个独立的 series
      // 相邻 series 共享边界点以确保线条连续
      const seriesList = [];
      let currentPeriod = periodTypes[0];
      let segmentStart = 0;
      
      for (let i = 1; i <= 24; i++) {
        // 在边界处或结束时创建 series
        if (i === 24 || periodTypes[i] !== currentPeriod) {
          const segmentData = new Array(24).fill(null);
          // 填充当前段的数据
          for (let j = segmentStart; j < i; j++) {
            segmentData[j] = data[j];
          }
          // 如果不是最后一段，包含下一个点以确保连接
          if (i < 24) {
            segmentData[i] = data[i];
          }
          
          seriesList.push({
            data: segmentData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 2,
              color: colorMap[currentPeriod]
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: hexToRgba(colorMap[currentPeriod], 0.4)
                },
                {
                  offset: 1,
                  color: hexToRgba(colorMap[currentPeriod], 0.05)
                }
              ])
            },
            connectNulls: true
          });
          
          // 开始新段
          if (i < 24) {
            currentPeriod = periodTypes[i];
            segmentStart = i;
          }
        }
      }
      
      this.peakValleyChartOption = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#1890ff',
          textStyle: { color: '#fff' },
          formatter: function(params) {
            if (!params || params.length === 0) return '';
            
            // 找到第一个有有效值的 series
            let validParam = null;
            for (let i = 0; i < params.length; i++) {
              if (params[i].value !== undefined && params[i].value !== null) {
                validParam = params[i];
                break;
              }
            }
            
            if (!validParam) return '';
            
            let result = validParam.name + '<br/>';
            const period = periodTypes[validParam.dataIndex];
            result += '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:' + colorMap[period] + ';"></span>';
            result += periodMap[period] + ': ' + validParam.value.toFixed(2) + 'kwh<br/>';
            return result;
          }
        },
        legend: {
          show: false // 隐藏内置图例，使用HTML自定义图例
        },
        grid: {
          left: '50',
          right: '20',
          top: '30',
          bottom: '30'
        },
        xAxis: {
          type: 'category',
          data: hours,
          boundaryGap: false,
          axisLine: { lineStyle: { color: '#1890ff' } },
          axisLabel: { 
            color: '#fff', 
            fontSize: 11,
            interval: 1
          }
        },
        yAxis: {
          type: 'value',
          name: '单位:kwh',
          nameTextStyle: { color: '#fff', fontSize: 11 },
          axisLine: { lineStyle: { color: '#1890ff' } },
          axisLabel: { color: '#fff', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(24, 144, 255, 0.2)' } }
        },
        series: seriesList
      };
    },
    // 根据小时和当前月份判断时间段（广东省TOU时段划分）
    getTimePeriod(hour) {
      const currentMonth = new Date().getMonth() + 1; // 1-12
      const isSummer = currentMonth >= 7 && currentMonth <= 9; // 7-9月为夏季
      
      if (isSummer) {
        // 夏季时段划分 (7-9月)
        if (hour >= 0 && hour <= 7) {
          return 'valley'; // 谷段: 0-7时
        } else if (hour >= 8 && hour <= 9 || hour >= 12 && hour <= 13 || hour >= 19 && hour <= 23) {
          return 'flat'; // 平段: 8-9, 12-13, 19-23时
        } else if (hour === 10 || hour === 14 || hour === 17 || hour === 18) {
          return 'high'; // 高峰: 10, 14, 17-18时
        } else if (hour === 11 || hour === 15 || hour === 16) {
          return 'peak'; // 尖峰: 11, 15-16时
        }
      } else {
        // 非夏季时段划分 (1-6月, 10-12月)
        if (hour >= 0 && hour <= 7) {
          return 'valley'; // 谷段: 0-7时
        } else if (hour >= 8 && hour <= 9 || hour >= 12 && hour <= 13 || hour >= 19 && hour <= 23) {
          return 'flat'; // 平段: 8-9, 12-13, 19-23时
        } else if (hour >= 10 && hour <= 11 || hour >= 14 && hour <= 18) {
          return 'high'; // 高峰: 10-11, 14-18时
        }
      }
      
      return 'flat'; // 默认平段
    },
    startAutoScroll() {
      // 自动滚动实时订单
      this.startOrderScroll();
      // 自动滚动实时告警
      this.startAlarmScroll();
    },
    stopAutoScroll() {
      // 停止自动滚动
      this.stopOrderScroll();
      this.stopAlarmScroll();
    },
    startOrderScroll() {
      this.$nextTick(() => {
        const orderBody = document.querySelector('.order-body');
        if (!orderBody) {
          console.warn('order-body element not found');
          return;
        }
        
        this.scrollTimer = setInterval(() => {
          if (!this.isScrollPaused) {
            orderBody.scrollTop += 1;
            // 当滚动到一半时（即第一组数据滚动完），重置到顶部实现无缝循环
            if (orderBody.scrollTop >= orderBody.scrollHeight / 2) {
              orderBody.scrollTop = 0;
            }
          }
        }, 50);
      });
    },
    stopOrderScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    pauseScroll() {
      this.isScrollPaused = true;
    },
    resumeScroll() {
      this.isScrollPaused = false;
      this.selectedIndex = -1;
    },
    selectOrder(index) {
      this.selectedIndex = index;
      this.isScrollPaused = true;
    },
    deselectOrder() {
      this.selectedIndex = -1;
      this.isScrollPaused = false;
    },
    startAlarmScroll() {
      this.$nextTick(() => {
        const alarmBody = document.querySelector('.alarm-body');
        if (!alarmBody) {
          console.warn('alarm-body element not found');
          return;
        }
        
        this.alarmScrollTimer = setInterval(() => {
          if (!this.isAlarmScrollPaused) {
            alarmBody.scrollTop += 1;
            if (alarmBody.scrollTop >= alarmBody.scrollHeight / 2) {
              alarmBody.scrollTop = 0;
            }
          }
        }, 50);
      });
    },
    stopAlarmScroll() {
      if (this.alarmScrollTimer) {
        clearInterval(this.alarmScrollTimer);
        this.alarmScrollTimer = null;
      }
    },
    pauseAlarmScroll() {
      this.isAlarmScrollPaused = true;
    },
    resumeAlarmScroll() {
      this.isAlarmScrollPaused = false;
      this.selectedAlarmIndex = -1;
    },
    selectAlarm(index) {
      this.selectedAlarmIndex = index;
      this.isAlarmScrollPaused = true;
    },
    deselectAlarm() {
      this.selectedAlarmIndex = -1;
      this.isAlarmScrollPaused = false;
    },
    startChargeAmountAnimation() {
      // 每隔一段时间更新充电量数字，触发翻转动效
      this.chargeTimer = setInterval(() => {
        this.updateChargeAmount();
      }, 3000);
    },
    stopChargeAmountAnimation() {
      if (this.chargeTimer) {
        clearInterval(this.chargeTimer);
        this.chargeTimer = null;
      }
    },
    updateChargeAmount() {
      // 模拟充电量增加，从右到左依次翻转更新数字
      const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      
      // 从最后一位开始，模拟数字递增效果
      for (let i = this.chargeAmountDisplay.length - 1; i >= 0; i--) {
        const currentDigit = this.chargeAmountDisplay[i];
        const currentIndex = digits.indexOf(currentDigit.current);
        const nextIndex = (currentIndex + 1) % 10;
        const nextDigit = digits[nextIndex];
        
        if (currentDigit.current !== nextDigit) {
          // 先立即更新数字
          currentDigit.current = nextDigit;
          currentDigit.next = nextDigit;
          
          // 强制重排以重置动画
          this.$nextTick(() => {
            // 然后触发翻牌动画
            currentDigit.flipping = true;
            
            // 动画结束后重置状态
            setTimeout(() => {
              currentDigit.flipping = false;
            }, 200);
          });
          
          // 只更新最后一位或进位的情况
          if (currentIndex !== 9) {
            break;
          }
        }
      }
    },
    updateChargeAmountDisplay(totalElec) {
      // 当电量为0、空或null时，显示为0.00
      let newElecStr;
      if (!totalElec || totalElec === '0' || totalElec === 0) {
        newElecStr = '0.00';
      } else {
        const numValue = parseFloat(totalElec) || 0;
        // 超过100万时，转换为万单位，保留2位小数
        if (numValue >= 1000000) {
          newElecStr = (numValue / 10000).toFixed(2);
        } else {
          newElecStr = numValue.toFixed(4);
        }
      }
      
      const newChars = newElecStr.split('');
      const oldLength = this.chargeAmountDisplay.length;
      const newLength = newChars.length;
      
      // 检查数据是否增长
      const oldValue = parseFloat(this.totalElecValue) || 0;
      const newValue = parseFloat(newElecStr) || 0;
      const isIncreasing = newValue > oldValue;
      
      // 长度增加：先添加新牌位，然后所有牌位翻牌
      if (newLength > oldLength) {
        // 先更新旧牌位的值
        for (let i = 0; i < oldLength; i++) {
          this.chargeAmountDisplay[i].current = newChars[i];
          this.chargeAmountDisplay[i].next = newChars[i];
        }
        
        // 添加新牌位
        for (let i = oldLength; i < newLength; i++) {
          this.chargeAmountDisplay.push({
            current: newChars[i],
            next: newChars[i],
            flipping: false,
            isNew: true
          });
        }
        
        this.totalElecValue = newElecStr;
        
        // 触发增长动效
        if (isIncreasing) {
          this.chargeAmountDiff = newValue - oldValue;
          this.chargeAmountIncreasing = true;
          setTimeout(() => {
            this.chargeAmountIncreasing = false;
            this.chargeAmountDiff = 0;
          }, 1500);
        }
        
        // 先让新牌位入场动画完成，然后触发翻牌动画
        this.$nextTick(() => {
          // 等待入场动画完成（300ms）后再触发翻牌
          setTimeout(() => {
            // 所有牌位触发翻牌动画
            this.chargeAmountDisplay.forEach(item => {
              item.flipping = true;
            });
            
            setTimeout(() => {
              this.chargeAmountDisplay.forEach(item => {
                item.flipping = false;
                item.isNew = false;
              });
            }, 400);
          }, 300);
        });
        return;
      }
      
      // 长度减少：直接重建数组
      if (newLength < oldLength) {
        this.chargeAmountDisplay = newChars.map(char => ({
          current: char,
          next: char,
          flipping: false
        }));
        this.totalElecValue = newElecStr;
        
        // 触发动画
        this.$nextTick(() => {
          this.chargeAmountDisplay.forEach(item => {
            item.flipping = true;
          });
          
          setTimeout(() => {
            this.chargeAmountDisplay.forEach(item => {
              item.flipping = false;
            });
          }, 400);
        });
        return;
      }
      
      // 长度相同，逐个更新并标记变化的位置
      const changedIndexes = [];
      this.chargeAmountDisplay.forEach((item, index) => {
        if (item.current !== newChars[index]) {
          item.current = newChars[index];
          item.next = newChars[index];
          changedIndexes.push(index);
        }
      });
      
      this.totalElecValue = newElecStr;
      
      // 触发增长动效
      if (isIncreasing) {
        this.chargeAmountDiff = newValue - oldValue;
        this.chargeAmountIncreasing = true;
        setTimeout(() => {
          this.chargeAmountIncreasing = false;
          this.chargeAmountDiff = 0;
        }, 1500);
      }
      
      // 触发动画
      if (changedIndexes.length > 0) {
        this.$nextTick(() => {
          changedIndexes.forEach(index => {
            this.chargeAmountDisplay[index].flipping = true;
          });
          
          setTimeout(() => {
            changedIndexes.forEach(index => {
              this.chargeAmountDisplay[index].flipping = false;
            });
          }, 400);
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.large-screen {
  width: 100vw;
  height: 100vh;
  background: url('../assets/images/large/BG.jpg') no-repeat center center;
  background-size: cover;
  color: #fff;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(ellipse at 20% 50%, rgba(24, 144, 255, 0.1) 0%, transparent 50%),
      radial-gradient(ellipse at 80% 50%, rgba(24, 144, 255, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }
}

// 顶部导航栏
.header {
  height: 101px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: url('../assets/images/large/nav_bg.gif') no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  z-index: 10;
}

.header-left, .header-right {
  display: flex;
  align-items: flex-start;
  padding-top: 26px;
  gap: 20px;
  flex: 1;
  height: 100%;
}

.header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  // padding-top: 25px;
  flex: 2;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.header-right {
  justify-content: flex-end;
}

.logo {
  width: 80px;
  height: 50px;
  object-fit: contain;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.filter-label {
  white-space: nowrap;
}

.filter-select {
  width: 120px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
    height: 2px;
    background: url('../assets/images/large/line.png') repeat-x center center;
    background-size: auto 2px;
  }
}

.header-center {
  text-align: center;
  flex: 2;
}

.title {
  font-size: 32px;
  font-weight: bold;
  background: linear-gradient(180deg, #fff 0%, #1890ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  letter-spacing: 8px;
}

.subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 5px;
}

/* 天气信息一行显示样式 */
.weather-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.weather-location {
  color: #1890ff;
  font-weight: 500;
}

.weather-divider {
  color: rgba(255, 255, 255, 0.3);
}

.weather-temp {
  color: #1890ff;
  font-weight: bold;
  font-size: 15px;
}

.weather-desc {
  color: rgba(255, 255, 255, 0.8);
}

.weather-humidity,
.weather-wind {
  color: rgba(255, 255, 255, 0.7);
}

.system-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.info-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #1890ff;
  white-space: nowrap;
  font-weight: 500;
}

.tenant-item {
  cursor: pointer;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-item .icon {
  width: 14px;
  height: 14px;
  display: inline-block;
  flex-shrink: 0;
}

.info-item:nth-child(1) .icon {
  background: url('../assets/images/large/backstage_icon.png') no-repeat center center;
  background-size: contain;
}

.admin-item .icon {
  background: url('../assets/images/large/user_icon.png') no-repeat center center;
  background-size: contain;
}

.datetime {
  text-align: right;
  line-height: 1.4;
  color: #1890ff;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.datetime .date {
  color: #1890ff;
}

.datetime .time {
  color: #1890ff;
}

.datetime .weekday {
  color: #1890ff;
}

.year-range-picker {
  display: flex;
  align-items: center;
  gap: 8px;
}

.year-range-picker .range-separator {
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}

.year-range-picker .year-picker {
  width: 120px !important;
}

.refresh-group {
  display: flex;
  align-items: center;
}

.refresh-select {
  width: 100px !important;
  height: 32px !important;
}

.refresh-select .el-input__wrapper {
  background: url('../assets/images/large/refresh_bg.png') no-repeat center center !important;
  background-size: 100% 100% !important;
  border: none !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  padding: 4px 8px 4px 28px !important;
  height: 100% !important;
}

.refresh-select .el-input__prefix {
  left: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.refresh-select .el-input__inner {
  color: #fff !important;
  padding-left: 0 !important;
  font-size: 14px !important;
  height: 100% !important;
  line-height: 32px !important;
}

.refresh-select .el-select__caret {
  color: #fff !important;
}

.refresh-icon {
  width: 14px;
  height: 14px;
  background: url('../assets/images/large/refresh_icon.png') no-repeat center center;
  background-size: contain;
  display: inline-block;
  margin-right: 4px;
}

// 主内容区
.main-content {
  display: flex;
  gap: 20px;
  padding: 10px;
  height: calc(100vh - 101px - 20px);
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.left-panel, .right-panel {
  width: 420px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.center-panel {
  flex: 1;
  min-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// 面板样式
.panel-box {
  background: rgba(8, 24, 49, 0.18);
  border: none;
  border-radius: 0;
  padding: 10px;
  position: relative;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

// 右侧面板各模块高度比例
.panel-utilization {
  flex: 0.9;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

.panel-device-status {
  flex: 1;
  display: flex;
  flex-direction: column;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

.device-status-chart {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 0;
}

.device-status-echarts {
  width: 55%;
  height: 100%;
  flex-shrink: 0;
  margin-left: -15px;
}

.device-status-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  padding-left: 0;
  z-index: 10;
  min-width: 0;
  font-size: 11px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
  
  &.color-使用中 {
    background: linear-gradient(180deg, #0066ff, #00aaff);
  }
  
  &.color-空闲 {
    background: linear-gradient(180deg, #00d4ff, #00aaff);
  }
  
  &.color-离线 {
    background: linear-gradient(180deg, #8c8c8c, #595959);
  }
  
  &.color-故障 {
    background: linear-gradient(180deg, #ff4d4f, #ff7875);
  }
}

.legend-text {
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}

.legend-detail {
  display: flex;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  flex-shrink: 0;
  
  span {
    white-space: nowrap;
  }
}

.panel-alarm {
  flex: 1.5;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

// 左侧面板各模块高度比例
.panel-stats {
  flex: 0.35;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

.panel-ranking {
  flex: 1.05;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

.panel-orders {
  flex: 1.5;
  opacity: 1;
  background: rgba(8, 24, 49, 0.18);
  backdrop-filter: blur(21.75px);
}

// 中间面板各模块高度比例
.center-panel .scale-data {
  flex: 1.5;
  min-height: 400px;
}

.center-panel .panel-peak-valley {
  flex: 0.75;
  opacity: 1;
  background: rgba(0, 50, 125, 0.18);
  backdrop-filter: blur(21.75px);
}

.panel-peak-valley .panel-title {
  background: url('../assets/images/large/title_bg3.png') no-repeat left center;
  background-size: contain;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  height: 36px;
  background: url('../assets/images/large/title_bg.png') no-repeat left center;
  // background-size: contain;
  padding: 0 12px 0 36px;
}

.title-icon {
  display: none;
}

.panel-extra {
  margin-left: auto;
  font-size: 12px;
  color: #1890ff;
}

.eye-icon {
  margin-left: auto;
  font-size: 16px;
  color: #1890ff;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    color: #40a9ff;
    transform: scale(1.1);
  }
}

// 今日数据统计
.panel-stats {
  flex: 0 0 auto;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.stat-item {
  background: url('../assets/images/large/today_data_bg.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  border-radius: 0;
  padding: 10px 15px;
  height: 70px;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: visible;
}

.stat-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.stat-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
  white-space: nowrap;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
}

.stat-unit {
  font-size: 12px;
  color: #1890ff;
}

.revenue-value {
  color: #FEDB65;
}

.revenue-value .stat-unit {
  color: #FEDB65;
}

// 今日数据增长动效的 + 号
.stat-scale-plus {
  position: absolute;
  top: -6px;
  right: -5px;
  font-size: 11px;
  color: #00ff88;
  font-weight: bold;
  opacity: 0;
  transform: scale(0) translateY(5px);
  text-shadow: 0 0 8px rgba(0, 255, 136, 0.8);
  white-space: nowrap;
}

.scale-increasing .stat-scale-plus {
  animation: scalePlusAppear 1.5s ease-out;
}

// 场站排行榜
.ranking-chart-wrapper {
  width: 100%;
  flex: 1;
  min-height: 0;
}

.ranking-chart {
  width: 100%;
  height: 100%;
}

// 实时订单
.order-table {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  color: #66FFFF;
}

.order-header {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid rgba(24, 144, 255, 0.2);
  color: rgba(255, 255, 255, 0.7);
  font-weight: bold;
  background: linear-gradient(180deg, #1453AE 0%, #1B3C6C 100%);
}

.order-body {
  flex: 1;
  overflow-y: auto;
  position: relative;
  min-height: 0;
  
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
  
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.order-scroll-wrapper {
  transition: transform 0.3s ease;
}

.order-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.order-row-selected {
    background: rgba(24, 144, 255, 0.15);
    color: #00d4ff;
  }
}

.col-select {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .select-icon {
    width: 16px;
    height: 16px;
  }
}

.col-time { width: 80px; }
.col-phone { width: 100px; }
.col-station { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.col-amount { width: 80px; text-align: center; }

// 规模数据
.scale-data {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1.2;
}

.scale-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  min-height: 36px;
}

.scale-title-bg {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 206px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-indent: 36px;
  flex-shrink: 0;
  z-index: 10;
}

.title-bg-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: -1;
}

.scale-title-text {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
}

.scale-title-bg .eye-icon {
  position: absolute;
  right: -24px;
  margin-left: 0;
}

.charge-display-wrapper {
  display: flex;
  justify-content: center;
}

.charge-display {
  display: flex;
  align-items: center;
  gap: 15px;
}

.charge-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.charge-unit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  align-self: center;
  margin-left: 4px;
}

.charge-unit-wan {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  align-self: center;
  margin-left: 4px;
}

/* 规模数据右上角信息 */
.scale-info {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: right;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}

.scale-info-line {
  white-space: nowrap;
}

.charge-numbers {
  display: flex;
  gap: 4px;
}

.flip-digit {
  width: 44px;
  height: 58px;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, #1e5a8a 0%, #0d3456 100%);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.flip-card {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flip-top,
.flip-bottom,
.flip-top-flip,
.flip-bottom-flip {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.flip-top {
  background: linear-gradient(180deg, #1e5a8a 0%, #164a72 100%);
  border-radius: 8px 8px 0 0;
  z-index: 2;
  clip-path: inset(0 0 50% 0);
}

.flip-bottom {
  background: linear-gradient(180deg, #164a72 0%, #0d3456 100%);
  border-radius: 0 0 8px 8px;
  z-index: 1;
  clip-path: inset(50% 0 0 0);
}

.flip-top-flip {
  background: linear-gradient(180deg, #1e5a8a 0%, #164a72 100%);
  border-radius: 8px 8px 0 0;
  z-index: 3;
  transform-origin: center bottom;
  backface-visibility: hidden;
  clip-path: inset(0 0 50% 0);
}

.flip-bottom-flip {
  background: linear-gradient(180deg, #164a72 0%, #0d3456 100%);
  border-radius: 0 0 8px 8px;
  z-index: 1;
  transform-origin: center top;
  backface-visibility: hidden;
  transform: rotateX(90deg);
  clip-path: inset(50% 0 0 0);
}

.flip-top-flip.flip-animate {
  animation: flipTopDown 0.3s ease-in-out forwards;
}

.flip-bottom-flip.flip-animate {
  animation: flipBottomDown 0.3s ease-in-out 0.05s forwards;
}

@keyframes flipTopDown {
  0% {
    transform: rotateX(0deg);
  }
  100% {
    transform: rotateX(-90deg);
  }
}

@keyframes flipBottomDown {
  0% {
    transform: rotateX(90deg);
  }
  100% {
    transform: rotateX(0deg);
  }
}

// 中间分割线
.flip-digit::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 4px;
  right: 4px;
  height: 1px;
  background: rgba(0, 0, 0, 0.3);
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: none;
}

// 新牌位入场动画
.flip-digit-new {
  animation: flipDigitAppear 0.3s ease-out;
}

@keyframes flipDigitAppear {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(-20px);
  }
  60% {
    transform: scale(1.1) translateY(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

// 规模数据增长动效
.scale-animate-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  transition: all 0.3s ease;
}

.scale-value {
  display: inline-block;
  transition: all 0.3s ease;
}

.scale-plus {
  position: absolute;
  top: -8px;
  right: -20px;
  font-size: 12px;
  color: #00ff88;
  font-weight: bold;
  opacity: 0;
  transform: scale(0) translateY(10px);
  text-shadow: 0 0 10px rgba(0, 255, 136, 0.8);
  white-space: nowrap;
}

// 数据增长时的动效
.scale-increasing .scale-value {
  animation: scaleValuePulse 1.5s ease-out;
}

.scale-increasing .scale-plus {
  animation: scalePlusAppear 1.5s ease-out;
}

@keyframes scaleValuePulse {
  0% {
    transform: scale(1);
    filter: brightness(1);
  }
  20% {
    transform: scale(1.3);
    filter: brightness(1.8);
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
  }
  40% {
    transform: scale(1.15);
    filter: brightness(1.5);
  }
  60% {
    transform: scale(1.2);
    filter: brightness(1.6);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
    text-shadow: none;
  }
}

@keyframes scalePlusAppear {
  0% {
    opacity: 0;
    transform: scale(0) translateY(10px);
  }
  20% {
    opacity: 1;
    transform: scale(1.5) translateY(-5px);
  }
  40% {
    transform: scale(1.2) translateY(0);
  }
  60% {
    transform: scale(1.3) translateY(-2px);
  }
  80% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(-10px);
  }
}

// 地图容器
.map-wrapper {
  position: relative;
  flex: 1;
  min-height: 280px;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.china-map {
  width: 100%;
  height: 100%;
}

// 地图导航面包屑
.map-breadcrumb {
  position: absolute;
  top: 100px;
  left: 15px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: rgba(0, 20, 40, 0.85);
  border: 1px solid rgba(0, 212, 255, 0.4);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.breadcrumb-item {
  font-weight: 500;
  white-space: nowrap;
  
  &.clickable {
    cursor: pointer;
    color: #00d4ff;
    transition: all 0.3s;
    
    &:hover {
      color: #00ffff;
      text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
    }
  }
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

// 返回全国地图按钮
.map-back-btn {
  position: absolute;
  top: 100px;
  left: 10px;
  z-index: 10;
  padding: 6px 16px;
  background: rgba(24, 144, 255, 0.3);
  border: 1px solid rgba(24, 144, 255, 0.6);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;

  &:hover {
    background: rgba(24, 144, 255, 0.5);
    border-color: #1890ff;
  }

  .back-icon {
    font-size: 16px;
  }
}

// 地图顶部悬浮数据
.map-top-data {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  gap: 15px;
  z-index: 10;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.top-data-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: url('../assets/images/large/map_top_data_bg.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 10px 20px;
  flex: 1;
  min-width: 0;
}

.data-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

.data-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.data-label {
  font-size: 14px;
  color: #fff;
}

.data-value {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 176, 237, 1);
  display: flex;
  align-items: center;
  gap: 5px;
}

.data-unit {
  font-size: 12px;
  color: rgba(0, 176, 237, 1);
}

// 地图左下方悬浮数据
.map-footer-data {
  position: absolute;
  bottom: 0px;
  left: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  z-index: 10;
  padding: 15px 20px 10px;
  background: url('../assets/images/large/map_footer_bg.png') no-repeat center center;
  background-size: 100% 100%;
}

.footer-data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.footer-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}

.footer-value-bg {
  position: relative;
  width: 120px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-bg-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
}

.footer-value {
  position: relative;
  z-index: 1;
  font-size: 16px;
  font-weight: bold;
  color: #66FFFF;
}

// 在建数据项样式
.build-item .footer-value {
  color: #C1D5FF;
}

// 图表容器
.chart-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.chart-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
  font-size: 12px;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: middle;
}

.peak-valley-chart {
  width: 100%;
  height: calc(100% - 30px);
}

// 设备利用率
.utilization-grid {
  display: flex;
  gap: 10px;
  justify-content: space-around;
  height: calc(100% - 42px);
  padding: 10px;
  box-sizing: border-box;
}

.utilization-item {
  flex: 1;
  display: flex;
  align-items: center;
}

.utilization-bg {
  background: url('@/assets/images/large/pile_data_icon.png') no-repeat center;
  background-size: 100% 100%;
  padding: 20px 20px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  box-sizing: border-box;
}

.utilization-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.utilization-icon {
  flex-shrink: 0;
  width: 63px;
  height: 73px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -38px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.utilization-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}

.utilization-value {
  font-size: 24px;
  font-weight: bold;
  color: #1FC6FF;
  line-height: 1.2;
  white-space: nowrap;
}

// 设备实时状态
.device-status {
  font-size: 12px;
}

.status-header {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid rgba(24, 144, 255, 0.2);
}

.status-bars {
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.status-bar-group {
  display: flex;
  gap: 10px;
}

.status-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
}

.status-body {
  max-height: 150px;
  overflow-y: auto;
}

.status-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.status-index {
  width: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.status-bar-item {
  flex: 1;
  height: 60px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.bar {
  width: 20px;
  border-radius: 2px 2px 0 0;
  
  &.blue { background: linear-gradient(180deg, #1890ff, #096dd9); }
  &.cyan { background: linear-gradient(180deg, #13c2c2, #08979c); }
  &.gray { background: linear-gradient(180deg, #8c8c8c, #595959); }
  &.red { background: linear-gradient(180deg, #ff4d4f, #cf1322); }
}

.status-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
  font-size: 12px;
}

// 实时告警
.alarm-table {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  color: #ff4d4f;
}

.alarm-header {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 77, 79, 0.3);
  color: rgba(255, 255, 255, 0.7);
  font-weight: bold;
  background: linear-gradient(180deg, #1453AE 0%, #1B3C6C 100%);
  
  .col-select {
    width: 20px;
  }
  
  .col-time {
    width: 130px;
  }
  
  .col-device {
    width: 100px;
    padding-right: 10px;
  }
  
  .col-name {
    width: 100px;
  }
  
  .col-status {
    width: 60px;
    text-align: center;
  }
}

.alarm-body {
  flex: 1;
  overflow-y: auto;
  position: relative;
  min-height: 0;
  
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
  
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.alarm-scroll-wrapper {
  transition: transform 0.3s ease;
}

.alarm-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 77, 79, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ff4d4f;
  
  &.alarm-row-selected {
    background: rgba(255, 77, 79, 0.15);
    color: #ff7875;
  }
  
  &.alarm-unhandled-row {
    color: #ff4d4f;
    font-weight: bold;
  }
}

.alarm-row .col-time {
  width: 130px;
  color: #ff4d4f;
}

.alarm-row .col-device {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ff4d4f;
  padding-right: 10px;
}

.alarm-row .col-name {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ff4d4f;
}

.alarm-row .col-status {
  width: 60px;
  text-align: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  
  &.status-pending {
    background: rgba(255, 77, 79, 0.2);
    color: #ff4d4f;
  }
  
  &.status-handled {
    background: rgba(82, 196, 26, 0.2);
    color: #52c41a;
  }
}
</style>

<style>
/* 下拉框输入框透明样式 */
.large-screen .filter-select.el-select {
  width: 120px;
  --el-fill-color-blank: transparent !important;
  --el-fill-color: transparent !important;
  --el-fill-color-light: transparent !important;
  --el-fill-color-lighter: transparent !important;
  --el-fill-color-extra-light: transparent !important;
  --el-fill-color-dark: transparent !important;
  --el-fill-color-darker: transparent !important;
  --el-fill-color-darkest: transparent !important;
  --el-border-color: transparent !important;
  --el-border-color-light: transparent !important;
  --el-border-color-lighter: transparent !important;
  --el-border-color-extra-light: transparent !important;
  --el-border-color-dark: transparent !important;
  --el-border-color-darker: transparent !important;
}

.large-screen .filter-select.el-select:not(.refresh-select) * {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper,
.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper::before,
.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper::after {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  padding: 4px 11px !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  outline: none !important;
}

.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper.is-focus,
.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper:hover,
.large-screen .filter-select.el-select:not(.refresh-select) .el-input__wrapper:focus-within {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.large-screen .filter-select.el-select:not(.refresh-select) .el-input__inner {
  color: #fff !important;
  background: transparent !important;
  background-color: transparent !important;
  font-size: 14px;
}

.large-screen .filter-select.el-select:not(.refresh-select) .el-select__caret {
  color: #fff !important;
  background-image: url(../assets/images/large/down_arrow.png) !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  width: 12px !important;
  height: 12px !important;
  font-size: 0 !important;
}

/* 下拉框弹出层样式 */
.custom-popper {
  background-color: #1a2a3a !important;
  border: 1px solid rgba(24, 144, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.custom-popper .el-select-dropdown__wrap {
  background-color: #1a2a3a !important;
}

.custom-popper .el-select-dropdown__list {
  background-color: #1a2a3a !important;
}

.custom-popper .el-select-dropdown__item {
  color: #fff !important;
  background-color: #1a2a3a !important;
}

.custom-popper .el-select-dropdown__item:hover {
  background-color: rgba(24, 144, 255, 0.3) !important;
}

.custom-popper .el-select-dropdown__item.is-selected {
  color: #1890ff !important;
  background-color: rgba(24, 144, 255, 0.2) !important;
}

.custom-popper .el-popper__arrow {
  display: none !important;
}

/* 日期范围选择器透明样式 */
.large-screen .date-range-picker {
  width: 260px !important;
  --el-fill-color-blank: transparent !important;
  --el-fill-color: transparent !important;
  --el-fill-color-light: transparent !important;
  --el-fill-color-lighter: transparent !important;
  --el-fill-color-extra-light: transparent !important;
  --el-fill-color-dark: transparent !important;
  --el-fill-color-darker: transparent !important;
  --el-fill-color-darkest: transparent !important;
  --el-border-color: transparent !important;
  --el-border-color-light: transparent !important;
  --el-border-color-lighter: transparent !important;
  --el-border-color-extra-light: transparent !important;
  --el-border-color-dark: transparent !important;
  --el-border-color-darker: transparent !important;
}

.large-screen .date-range-picker .el-input__wrapper,
.large-screen .date-range-picker .el-input__wrapper::before,
.large-screen .date-range-picker .el-input__wrapper::after {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  padding: 4px 11px !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  outline: none !important;
}

.large-screen .date-range-picker .el-input__wrapper.is-focus,
.large-screen .date-range-picker .el-input__wrapper:hover,
.large-screen .date-range-picker .el-input__wrapper:focus-within {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.large-screen .date-range-picker .el-input__inner {
  color: #fff !important;
  background: transparent !important;
  background-color: transparent !important;
  font-size: 14px !important;
}

.large-screen .date-range-picker .el-range-editor.el-input__wrapper {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 4px 11px !important;
}

.large-screen .date-range-picker .el-range-separator {
  color: rgba(255, 255, 255, 0.6) !important;
  background: transparent !important;
}

.large-screen .date-range-picker .el-range-input {
  background: transparent !important;
  background-color: transparent !important;
  color: #fff !important;
}

.large-screen .date-range-picker .el-range__icon {
  background: transparent !important;
  color: #fff !important;
}

.large-screen .date-range-picker .el-range__close-icon {
  background: transparent !important;
  color: #fff !important;
}

/* 年份范围选择器样式 */
.large-screen .year-range-picker {
  display: flex;
  align-items: center;
  gap: 8px;
}

.large-screen .year-range-picker .range-separator {
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}

.large-screen .year-range-picker .year-picker {
  width: 120px !important;
}

/* // F11全屏样式优化 - 通过JS检测全屏状态添加is-fullscreen类 */
body.is-fullscreen {
  .main-content {
    height: calc(100vh - 101px);
    padding: 15px;
    gap: 15px;
  }
  
  .left-panel, .right-panel {
    width: 460px;
    gap: 2px;
  }
  
  /* 全屏模式下固定高度，减少空隙 */
  .panel-stats {
    flex: none;
    height: 220px;
  }
  
  .panel-ranking {
    flex: none;
    height: 280px;
  }
  
  .panel-utilization {
    flex: none;
    height: 160px;
  }
  
  .panel-device-status {
    flex: none;
    height: 280px;
  }
  
  /* 实时订单和实时告警占据剩余空间 */
  .panel-orders {
    flex: 1;
    min-height: 0;
  }
  
  .panel-alarm {
    flex: 1;
    min-height: 0;
  }
  
  .panel-box {
    padding: 12px;
  }
  
  .panel-title {
    margin-bottom: 12px;
    height: 36px;
  }
}
</style>